/**
 * 样式处理说明：
 * 只有pc 到1000以下就滚动条
 *  只有移动端数据 到1000就居中
 * 有pc有移动端数据 正常的兼容
 *
 * 多语言说明：
 * 默认语言规则：优先判断用户缓存的语言选项；- 无缓存，以用户浏览器语言为准。dwi323n1
 * 默认英文 简体 繁体 都为中文
 * 使用语言字段判断： language: CH/EN/CH_EN
 * 多语言数据：一次性返回中文 英文配置  pcEn mobilEn bookingEn。
 * 多语言数据数据使用：数据使用固定，通过语言规则判断更改使用数据 ，例如使用mobilEn 还是mobil数据。
 * 留资数据： booking和bookingEn 也需要能切换语言
 * 约课到结果页的completionPageWriting 不再传入 约课页处理 因为有多语言切换
 *
 * 静态渲染说明
 * 后台获取所有页面id 提前渲染所有页面 将页面每次获取配置数据 提前到生产页面的那次 减少接口请求
 * 页面加载后再处理数据
 * abtest 无法预取处理：加载页面后需要通过v样式id重新获取页面数据
 *
 * 多版本说明
 * 通用版-海外IP访问，与现有保持一致
 * 专属版-国内IP访问，在现有逻辑的基础上、区号组件开放+86
 * quizData?.multipleVersionsForms true为多版本表单
 * 调用接口查询使用哪个版本表单 showChinaDomestic:true 获取专属表单 false使用多版本
 * 然后将 universalQuizData 或者 exclusiveQuizData值扩展到 quizData 内 （修改 setConfiguration）
 */

/**
 * 中文科目留资逻辑不变，没有年级选项，后台不会配置
 *
 * 数学，英文科目取消年龄选择选项，但一般会配置年级展示（业务说肯定会配）
 * 改点为在数学和英文科目下取消年龄展示
 *
 */

/**
 * 验证码重复 问题 以及 loading提前关闭 （能做的是 提交过程中 避免用户再次点击，不能避免已提醒重复提交 用户依然去点击提交 验证码依然会使用两次）
 * 留资成功后  按钮不允许次点击 submitting.current 依然为true 只有失败的时候改为false
 * 同时关闭验证码弹窗
 * loading 关闭时机 错误立即关闭, 其余的延迟到jumpResult跳转前关闭
 * 所以 提交的时候 错误的时候关闭 关闭loading submitting false
 */

import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import dynamic from 'next/dynamic';
import { useAsync, useLocation } from 'react-use';
const Select = dynamic(() => import('react-select'), { ssr: true });
import classNames from 'classnames';
import Cookies from 'js-cookie';
import cookie from 'cookie';
import { capitalize, debounce, lowerCase, shuffle, isEmpty } from 'lodash';
import dayjs from 'dayjs';
import RCForm from 'rc-field-form';
import qs from 'query-string';
import { useRouter } from 'next/router';
import FormItem from '@/components/FormItem';
import Input from '@/components/Input';
import Button from '@/components/Button';
import useQuery from '@/hooks/useQuery';
import LoadingModal from '@/components/Loading';
import { useMediaQuery } from 'react-responsive';

const PhoneInputMobile = dynamic(() => import('@/components/PhoneInput'), { ssr: true });
import Toast from '@/components/Toast';
import PC from '@/components/Device/PC';

const ImageNext = dynamic(() => import('next/image'), { ssr: true });
import { LazyLoadImage as Image } from 'react-lazy-load-image-component';

import { getConfigurableSever, getIPCountries } from '@/api/serverPublicRequest';
import {
  createLeadNoRemindNew,
  getClueTrackInfo,
  getCountryNew,
  getJsonNode,
  getMultipleVersionType,
  getStudentDayAndClass,
  sendPosterReportEvent,
} from '@/api/common';

import { install } from 'ga-gtag';

import {
  EMAIL_REG,
  GDT_L_PARAMS,
  GTM_FORM_CONFIGURABLE,
  PHONE_REG,
  REPORT_CLI_IPT_BTN_GET,
  REPORT_CLI_IPT_BTN_SUCTION_BOTTOM,
  REPORT_CLI_IPT_ENGLISH_NAME,
  REPORT_CLI_IPT_MAIL,
  REPORT_CLI_IPT_NAME,
  REPORT_CLI_IPT_PHONE,
  REPORT_FERM_WRONGFORM,
  REPORT_LOAD_TIME,
  REPORT_PAGE_NAME_LANDING_CONFIGURABLE,
  REPORT_PAGE_PERFORMANCE,
  REPORT_PV_RETAINED_CAPITAL,
  REPORT_UV_RETAINED_CAPITAL,
  CURRENT_LANGUAGE,
  USE_DEFAULT_ADS_GA_IDS,
  GA4_IDS_MAP,
} from '@/utils/constants';
import Head from 'next/head';
import Script from 'next/script';
import { getBasicInfo, traceEvent } from '@wk/wk-gatherer';
import useIsMobile from '@/hooks/useIsMobile';
import withGTMInjectScript from '@/HOC/withGTMWX';
import useGTM from '@/hooks/useGTM';
import {
  getConfigurable,
  getIsPayingUser,
  getLessonAvailableDateList,
  getUserGradeList,
} from '@/api/laning-configurable';
import { trackCreateBeforeSkip } from '@/api/commonGatWay';
import {
  expandSubjectsLabelNoRemind,
  getOldUserStudentCode,
  getStudentInformation,
  haveAppointmentRecord,
} from '@/api/lead';
import loadTime from '@/hooks/loadTime';
import useAnalyse from '@/hooks/useAnalyse';
import { messageIsRepeat } from '@/utils/informationJudgment';

const Nav = dynamic(() => import('@/components/landing/Nav'), { ssr: true });
import { useGetDevice } from '@/hooks/useGetDevice';

import {
  ConfigurationPcMobileProps,
  ConfigurationProps,
  CountryResponse,
  FormTypeConfig,
  IFormDefaultData,
  IStudentCourseInfo,
  PixelData,
} from '@/components/landing/interface';
import { objectToBase64, phoneTwilioIsVerify, pxConversionVMin, getParameterValues } from '@/utils/utils';

import styles from './style.module.scss';
import { report } from '@/utils/buryingPoint';

const PhoneInput = dynamic(() => import('@/components/landing/PhoneInput'), { ssr: true });
const TopTips = dynamic(() => import('@/components/landing/TopTips'), { ssr: false });
import { BarrageData } from '@/components/landing/TopTips/lottery-list-new';
import {
  FB_VALUE_MAP,
  FORM_TYPE_CONFIG,
  LANDING_CONFIGURABLE_EN,
  LANDING_CONFIGURABLE_ZH,
  LANGUAGE_EN,
  LANGUAGE_ZH,
  SUBJECT_MAP_EN,
  SUBJECT_MAP_ZH,
  VBB_VALUE_MAP,
} from '@/components/landing/constants';

const DetainmentModal = dynamic(() => import('@/components/landing/DetainmentModal'), { ssr: true });
import 'react-placeholder/lib/reactPlaceholder.css';
import { GetServerSideProps } from 'next/types';
import useGEC from '@/hooks/useGEC';
import { getAgeOptions, getPCFixed, getThemeColor, getGradeOptions } from '@/utils/landing';
import { TrackLandingController } from '@/track';
import { getUserDefaultLanguage } from '@/utils/cookie';
import useGTag from '@/hooks/useGtag';
import { createOpenClassLead } from '@/api/commonGatWay';

const Countdown = dynamic(() => import('@/components/landing/Countdown'), { ssr: true });
import { VerificationInfo } from '@/components/landing/VerifyDrawer';

const VerifyDrawer = dynamic(() => import('@/components/landing/VerifyDrawer'), { ssr: false });
const VerifyModal = dynamic(() => import('@/components/landing/VerifyModal'), { ssr: true });

import { isWechatEnvironment, authLogin, isMiniProgram } from '@/utils/wechat';
import { wechatLogin2 } from '@/api/wechat';

const { FIELDS_MAP, doTrack, EVENT_NAME_MAP } = TrackLandingController;

const scrollToTop = () => {
  const sTop = document.documentElement.scrollTop || document.body.scrollTop;
  if (sTop > 0) {
    window.requestAnimationFrame(scrollToTop);
    window.scrollTo(0, sTop - sTop / 4);
  }
};

const LEAVE_DELAY = 10000; // 离开延迟时间，单位毫秒
const STAY_DELAY = 10000; // 停留延迟时间，单位毫秒

// 定义twillo 校验的不同状态，用于处于提交表单时，还在校验中的情况
export enum TwilloCheckingStatus {
  INIT = 'INIT',
  WAITING = 'WAITING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

const MOBILE_REG = '.*iPhone|Android|SymbianOS|Windows Phone|iPod|MiniProgramEnv{1,}.*';

import { ServerResponse } from 'http';

export const setServerCookie = (res: ServerResponse, localeData: 'CH' | 'EN') => {
  const langMap: Record<string, string> = {
    CH: 'zh',
    EN: 'en',
  };

  const lang = langMap[localeData] || '';

  // 删除旧的 cookie
  res.setHeader('Set-Cookie', [
    cookie.serialize(CURRENT_LANGUAGE, '', {
      domain: '.wukongedu.net',
      path: '/',
      expires: new Date(0),
    }),
    cookie.serialize(CURRENT_LANGUAGE, '', {
      domain: '.wukongsch.com',
      path: '/',
      expires: new Date(0),
    }),
  ]);

  // 设置新的 cookie
  if (lang) {
    res.setHeader(
      'Set-Cookie',
      cookie.serialize(CURRENT_LANGUAGE, lang, {
        path: '/',
      }),
    );
  }
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { params, req, res } = context;
  const ua = req.headers['user-agent'];
  const acceptLanguage = req.headers['accept-language'] || '';
  let serverIsMobile = true;
  let serverStyleType: 'pcMobile' | 'AllPC' | 'AllMobile' = 'pcMobile';
  const cookies = cookie.parse(req.headers.cookie || '');
  const cookieLanguage = cookies[CURRENT_LANGUAGE];
  const navigatorLanguage = acceptLanguage;

  // 获取用户默认语言
  let userDefaultLanguage = '';
  // 用户是否有选择过语言 优先使用选择语言
  if (cookieLanguage) {
    userDefaultLanguage = cookieLanguage.toLowerCase();
    // 浏览器默认语言
  } else if (navigatorLanguage.startsWith('zh')) {
    userDefaultLanguage = 'zh';
  } else {
    // 系统语言
    userDefaultLanguage = navigatorLanguage;
  }
  let serverLanguage = 'EN';

  if (ua && ua.match(MOBILE_REG)) {
    serverIsMobile = true;
  } else {
    serverIsMobile = false;
  }
  let configuration: ConfigurationProps = {};
  try {
    if (params?.id) {
      configuration = await getConfigurableSever({ id: params?.id as string });
    }
  } catch (error) {
    console.log('sever get configurationProps err', error);
  }
  let userIp = '';
  // 如果是多版本表单 查询国家 然后输出对应配置数据
  if (configuration?.quizData?.multipleVersionsForms) {
    // 获取客户端的 IP 地址
    const forwarded = context.req.headers['x-forwarded-for'];
    const ip = (Array.isArray(forwarded) ? forwarded[0] : forwarded) || context.req.socket.remoteAddress;
    // 确保 ip 是字符串，并处理可能的多个 IP 地址
    userIp = typeof ip === 'string' ? ip.split(',')[0].trim() : '';
    let showChinaDomestic = false;
    // cp-l域名会解析到香港
    if (ip === '8.218.220.57') {
      showChinaDomestic = true;
    } else {
      const IPCountrie = await getIPCountries(userIp);
      showChinaDomestic = IPCountrie.country === 'China';
    }
    // 根据 showChinaDomestic 的值来设置 updatedQuizData
    const updatedQuizData = showChinaDomestic
      ? { ...configuration.exclusiveQuizData }
      : { ...configuration.universalQuizData };
    // console.log('showChinaDomestic', showChinaDomestic);
    // 更新 config?.quizData 属性值
    configuration.quizData = {
      ...configuration.quizData,
      ...updatedQuizData,
      showChinaDomestic,
      // 使用的多版本id
      multipleVersionType: showChinaDomestic
        ? configuration.quizData?.exclusiveId
        : configuration.quizData?.universalId,
    };
  }

  const handleConversionLanguage = (lang?: string) => {
    if (!lang) {
      return 'EN';
    }

    if (lang === 'CH_EN') {
      if (userDefaultLanguage === 'zh') {
        setServerCookie(res, 'CH');
        return 'CH';
      }
      setServerCookie(res, 'EN');
      return 'EN';
    }
    setServerCookie(res, lang as 'CH' | 'EN');
    return lang;
  };

  // 判断语言是 是否是双语 CH_EN ，双语走判断逻辑
  const defaultLanguage = handleConversionLanguage(configuration?.quizData?.language || 'EN');
  serverLanguage = defaultLanguage;
  // console.log('serverLanguage', serverLanguage);

  let useEnData = configuration.quizData?.language === 'CH_EN' && defaultLanguage === 'EN';

  let configActiveData: ConfigurationPcMobileProps = {};
  // 调用配置接口数据，根据浏览器信息，输出对应pc或者移动数据，仅配置移动端情况依然会闪烁，
  if (!isEmpty(configuration)) {
    const quizData = configuration.quizData;
    const mobilDataOg = quizData?.mobil;
    const mobilData = {
      ...quizData?.mobil,
      // 优先去booking二维码 没有取配置的 兼容旧数据
      completionPageQRCode:
        quizData?.booking?.completionPageBookingQRCodeUrl || quizData?.mobil?.completionPageQRCode || '',
      completionPageWriting: quizData?.booking?.completionPageWriting || quizData?.mobil?.completionPageWriting || '',
      rewards: quizData?.booking?.rewards || [],
      bookingFlow: quizData?.booking?.bookingFlow || 'SIMPLE',
    };
    let pcDataOg = Object.keys((quizData?.pc as object) || {}).length <= 2 ? {} : quizData?.pc;

    const pcData = {
      ...quizData?.pc,
      completionPageQRCode:
        quizData?.booking?.completionPageBookingQRCodeUrl || quizData?.pc?.completionPageQRCode || '',
      completionPageWriting: quizData?.booking?.completionPageWriting || quizData?.pc?.completionPageWriting || '',
      rewards: quizData?.booking?.rewards || [],
      bookingFlow: quizData?.booking?.bookingFlow || 'SIMPLE',
    };
    const mobileEnData = {
      ...quizData?.mobilEn,
      completionPageQRCode:
        quizData?.bookingEn?.completionPageBookingQRCodeUrl || quizData?.mobilEn?.completionPageQRCode || '',
      completionPageWriting:
        quizData?.bookingEn?.completionPageWriting || quizData?.mobilEn?.completionPageWriting || '',
      rewards: quizData?.bookingEn?.rewards || [],
      bookingFlow: quizData?.bookingEn?.bookingFlow || 'SIMPLE',
    };
    const pcEnData = {
      ...quizData?.pcEn,
      completionPageQRCode:
        quizData?.bookingEn?.completionPageBookingQRCodeUrl || quizData?.pcEn?.completionPageQRCode || '',
      completionPageWriting: quizData?.bookingEn?.completionPageWriting || quizData?.pcEn?.completionPageWriting || '',
      rewards: quizData?.bookingEn?.rewards || [],
      bookingFlow: quizData?.bookingEn?.bookingFlow || 'SIMPLE',
    };

    if (!isEmpty(mobilDataOg) && !isEmpty(pcDataOg)) {
      if (serverIsMobile) {
        configActiveData = (useEnData ? mobileEnData : mobilData) || {};
      } else {
        configActiveData = (useEnData ? pcEnData : pcData) || {};
      }
    }
    if (!isEmpty(mobilDataOg) && isEmpty(pcDataOg)) {
      configActiveData = (useEnData ? mobileEnData : mobilData) || {};
      serverStyleType = 'AllMobile';
    }
    if (!isEmpty(pcDataOg) && isEmpty(mobilDataOg)) {
      configActiveData = (useEnData ? pcEnData : pcData) || {};
      serverStyleType = 'AllPC';
    }
  }

  return {
    props: {
      configurationOriginalData: configuration,
      configActiveDataOriginalData: configActiveData,
      serverIsMobile,
      userIp,
      serverLanguage,
      serverStyleType,
    },
  };
};

interface FormValues {
  phone: Array<string>;
  name: string;
  englishName: string;
  mail: string;
  customInput1Key: string;
  customInput2Key: string;
  age: { value: string };
  grade: { value: string };
  code: string;
  serveLanguage?: { value: string };
}

interface CreateLead {
  mail: string;
  name: string;
  englishName: string;
  customInput1Key: string;
  customInput2Key: string;
  phone: Array<string>;
  // 推荐人code
  code?: string;
  age?: { value: string };
  grade?: { value: string };
  serveLanguage?: { value: string };
  verificationCode?: string;
  mobileVerified?: boolean;
}

const specialPageIds = new Set(USE_DEFAULT_ADS_GA_IDS);

const ChineseLanding = (props: {
  configurationOriginalData: ConfigurationProps;
  configActiveDataOriginalData: ConfigurationPcMobileProps;
  serverIsMobile: boolean;
  userIp: string;
  serverLanguage: string;
  serverStyleType: 'pcMobile' | 'AllPC' | 'AllMobile';
}) => {
  const router = useRouter();
  const query = useQuery();
  // console.log(props, router, 'all props with router');
  const {
    configurationOriginalData = {},
    configActiveDataOriginalData = {},
    serverIsMobile,
    userIp,
    serverLanguage,
    serverStyleType,
  } = props;
  // console.log('userIp-->', userIp);
  const { token = '', id, type = '', week = '' } = router.query as Record<string, string>;
  const [isAppSource, setIsAppSource] = useState<boolean>(type.includes('app_android') || type.includes('app_ios'));
  // code 推荐人学号 可能是转介绍海报的链接 需要讲code带入接口参数
  // studentCode 当前学生的学号  之前扩科用
  const fromParams = useRef<any>();

  const {
    l = '',
    studentCode = '',
    posterId = '',
    v = '',
    // 推荐人code code转换
    recommenderCode = '',
    gclid = '',
    edmActivityId = '',
    recommendStudentSId = '',
    assignAccountId = '',
    shareId = '',
    ocrCode = '',
  } = useQuery() as Record<string, string>;
  const sendDataToGTM = useGTM('LC_');
  const { broadcastGTM } = useGEC();
  // 是否移动端 客户端
  const customerIsMobile = useMediaQuery({ maxWidth: 721 });
  const [isMobile, setIsMobile] = useState(serverIsMobile);
  const [form] = RCForm.useForm();
  const [time] = loadTime();
  const [analyse] = useAnalyse();
  // banner高度rf
  const bannerRef = useRef<HTMLDivElement>(null);
  // 是否点击了输入框
  const formClickStatusRef = useRef({
    phone: false,
    mail: false,
    name: false,
    englishName: false,
  });
  // 是否 能展示挽留 只有为true 才展示，关闭后和展示过一次后都为false
  const isLeavingRef = useRef(false);
  // eslint-disable-next-line no-unused-vars
  const [curPlatform, tokenApp, deviceSimpleInfo] = useGetDevice();
  const [hideBtn, setHideBtn] = useState(true);
  // 获取的页面配置
  const [configuration, setConfiguration] = useState<ConfigurationProps>(configurationOriginalData);
  // 当前pc移动配置
  const [configurationActive, setConfigurationActive] =
    useState<ConfigurationPcMobileProps>(configActiveDataOriginalData);
  // 国家区号
  const [countryCode, setCountryCode] = useState();
  const [countryData, setCountryData] = useState<CountryResponse>({});
  // 提交信息loading
  const submitting = useRef(false);
  // 页面语言 'CH' | 'EN'
  const [language, setLanguage] = useState(serverLanguage || 'EN');
  // 页面语言文案
  const [langText, setLangText] = useState(serverLanguage === 'EN' ? LANDING_CONFIGURABLE_EN : LANDING_CONFIGURABLE_ZH);
  // 载入页面Placeholder
  const [loadingPlaceholder, setLoadingPlaceholder] = useState(true);
  // 获取渠道数据： 1级，2级，追踪代码类别
  const [pixel, setPixel] = useState<PixelData>({});
  // 落地页功能 配置  CLASS扩科 FORM表单
  const formTypeConfig = useRef<FormTypeConfig>(FORM_TYPE_CONFIG.DEFAULT);
  // 表单默认数据
  const [formDefaultData, setFormDefaultData] = useState<IFormDefaultData>({});
  // 查询学生信息数据
  const [studentInfo, setStudentInfo] = useState<IFormDefaultData>({});
  // d版本学员信息
  const [studentCourseInfo, setStudentCourseInfo] = useState<IStudentCourseInfo>();
  // 侧边按钮显示
  const [sideHide, setSideHide] = useState(true);
  // 年龄输入框增加判断，输入完手机号显示
  const [isAgeInput, setIsAgeInput] = useState<boolean>(false);
  // 邮箱输入框增加判断，输入完手机号正确位数后显示
  const [isEmailInput, setIsEmailInput] = useState<boolean>(false);
  // 手机验证码， 选择手机区号与时区不同时显示
  const [isPhoneVerify, setIsPhoneVerify] = useState<boolean>(false);
  // 存储接口获取时区手机区号状态
  const [startPhone, setStartPhone] = useState('');
  // 存储手动选择获取时区手机区号状态
  const [startPhoneCode, setStartPhoneCode] = useState('');
  // 台湾地区+886 不受接口返回限制出现验证码
  const [isSpecialCode, setIsSpecialCode] = useState<boolean>(false);
  // 埋点页面名称
  const pageName = `${REPORT_PAGE_NAME_LANDING_CONFIGURABLE}_${id}`;
  // gclid 获取trackingCode
  const [trackingCode, setTrackingCode] = useState<string>('GA');
  const [gclIdTrunk, setGclId] = useState<string>('');
  // 线索前置 存储id
  const [trackCreateBeforeId, setTrackCreateBeforeId] = useState<string>('');
  const [lotteryBarrage, setLotteryBarrage] = useState<any[]>([]);
  const [detainmentVisible, setDetainmentVisible] = useState(false);
  const [leaveTimer, setLeaveTimer] = useState<number>();
  const [stayTimer, setStayTimer] = useState<number>();
  // 用户自主选择隐私协议
  const [checked, setChecked] = useState<boolean>(false);
  const checkedRef = useRef<boolean>(false);

  // 隐私协议error提示
  const [checkedError, setCheckedError] = useState<boolean>(false);
  const [formCountryCode, setFormCountryCode] = useState('');
  // twillio 验证码
  const [twillio, setTwillio] = useState<boolean>(false);
  const [twillioResponse, setTwillioResponse] = useState<boolean>(true);
  const [verifyModalVisible, setVerifyModalVisible] = useState<boolean>(false);
  const [verifyDrawerVisible, setVerifyDrawerVisible] = useState<boolean>(false);
  const [formValues, setFormValues] = useState<FormValues>();
  const state = useLocation();
  // 官网谷歌
  const [officialWebsiteGa4, setOfficialWebsiteGa4] = useState<boolean>(false);
  //
  const [gradeListByRequest, setGradeListByRequest] = useState();
  const [environment, setEnvironment] = useState('');
  const [iPCode, setCountryIPCode] = useState();
  // console.log('configurationActive', configurationActive);
  // 如果拓科并且能够获取学生信息的情况，邮箱与年龄不需要隐藏，直接展示
  const isGetStudentInfo = formTypeConfig.current.freshStudentInfo && studentCode;
  const sendGTag = useGTag();
  const twillioCheckingRef = useRef(TwilloCheckingStatus.INIT);
  // 埋点默认数据
  const reportParams = useRef({
    l,
    subject: 'CHINESE',
    landingPageVersion: pageName,
    pv: null,
    uv: null,
    testType: v || null,
    multipleVersionType: '',
    L_parameter: l,
    Code: studentCode,
    type: id,
  });

  const memorizedHandleVerifyModalVisible = useCallback(
    (b: boolean) => {
      setVerifyModalVisible(b);
    },
    [setVerifyModalVisible],
  );

  const memorizedHandleVerifyDrawerVisible = useCallback(
    (b: boolean) => {
      setVerifyDrawerVisible(b);
    },
    [setVerifyDrawerVisible],
  );

  const commonReportParams = useRef({
    // 全埋点新增公共字段 V1.0.0
    pageId: id, // 页面id
    // 推广的创建日期
    whenCreated: '', // 根据l参获取
    // 动态表单名称
    quizName: '', // 根据页面id获取
    // 渠道
    channel1: '', // 根据l参获取
    channel2: '', // 根据l参获取
    channel3: '', // 根据l参获取
  });

  const doTrackList = (fields: symbol[]) => {
    const [symbol1, symbol2] = fields;
    doTrack(symbol1, { ...reportParams.current }, true);
    doTrack(symbol2, { ...reportParams.current });
  };

  // 样式类型
  // pc和移动 pc 移动
  const [styleType, setStyleType] = useState<'pcMobile' | 'AllPC' | 'AllMobile'>(serverStyleType);
  // 扩科 countryCode country 从 url取 ; 并且不可更改；

  // 解析token
  const tokenToJson = (token: string): any => {
    const strings = token.split('.'); // 截取token，获取载体
    // 解析，需要吧‘_’,'-'进行转换否则会无法解析
    return JSON.parse(decodeURIComponent(window.atob(strings[1].replace(/-/g, '+').replace(/_/g, '/'))));
  };

  // 可配置 默认语言为中文
  // 分步骤 默认语言为英文
  // 会导致 留资是中文 到分步骤约课是英文
  // 可配置 和 留资后置 根据当前语言 设置语言cookie 保证前后一致
  const setCookie = (localeData: 'CH' | 'EN') => {
    const langMap = {
      CH: 'zh',
      EN: 'en',
    };

    const lang = langMap[localeData] || '';

    Cookies.remove(CURRENT_LANGUAGE, {
      domain: '.wukongedu.net',
      path: '/',
    });
    Cookies.remove(CURRENT_LANGUAGE, {
      domain: '.wukongsch.com',
      path: '/',
    });

    if (lang) {
      Cookies.set(CURRENT_LANGUAGE, lang);
    }
  };

  useEffect(() => {
    getUserGradeList({ leadType: configuration.quizData?.subject || 'CHINESE' }).then((res) => {
      setGradeListByRequest(res);
    });
    submitting.current = false;
    // 清理 ReserveForm pageConfig 避免留资完返回留资页 分不走的数据使用上一个人
    sessionStorage.removeItem('createData');
    sessionStorage.removeItem('pageConfig');
    sessionStorage.removeItem('ReserveForm');
  }, []);

  useEffect(() => {
    // 如果是多版本表单 使用多版本逻辑
    // if
    getCountryNew({ showChinaDomestic: true }).then((res) => {
      setCountryIPCode(res?.data?.countryCode);
    });
  }, []);

  // console.log('!configuration?.quizData?.showChinaDomestic', !configuration?.quizData?.showChinaDomestic);
  // 获取国家区号
  useEffect(() => {
    if (!router.isReady) return;
    console.log('原始配置数据 configurationOriginalData', configurationOriginalData);
    const isApp = type.includes('app_android') || type.includes('app_ios');
    setIsAppSource(isApp);
    if (router?.query?.type && (token || tokenApp)) {
      // app内设置禁用 避免回填当前国家 使用本身区号
      formTypeConfig.current.phoneSelectDataDisabled = true;
      const tokenData = tokenToJson(token || tokenApp);
      const { phone, data, name, email } = tokenData;
      form.setFieldsValue({
        name,
        phone: (phone && [phone.split(' ')[0] || '', phone.split(' ')[1] || '', '']) || [],
        countryCode: phone && phone.split(' ')[0],
        studentCode: data.code,
        email,
      });
    }
    setLotteryBarrage(shuffle(BarrageData));
  }, [router.isReady, token, tokenApp]);

  const handleGetCountry = (showChinaDomestic = false) => {
    console.log('showChinaDomestic', showChinaDomestic);
    getCountryNew({ showChinaDomestic: showChinaDomestic }).then((res) => {
      setCountryData(res?.data);
      setCountryCode(res?.data?.countryList);
      const countryData = {
        country: res?.data?.country,
        timeZone: {
          label: res?.data?.timeZone?.itemName,
          value: res?.data?.timeZone?.itemValue,
        },
      };
      setStartPhone(res.data.countryCode);
      sessionStorage.setItem('countryData', JSON.stringify(countryData) || '');

      // 是否 禁用 手机下拉数据
      // 扩科不回填ip国别号
      if (!formTypeConfig.current.phoneSelectDataDisabled) {
        form.setFieldsValue({
          phone: [res.data.countryCode, form.getFieldValue('phone')?.[1] || '', res.data.country || ''],
        });
        setStartPhone(res.data.countryCode);
      }
    });
  };

  // 根据科目和年龄 判断是否在年龄服务范围
  const serviceAgeScope = (value: { subject?: string; age?: string }): boolean => {
    const { subject = 'CHINESE', age } = value;
    if (!age) {
      return true;
    }
    // over18 也不跳转约课
    if (age.length > 5) {
      return false;
    }

    const ageNum = Number(age);
    const serviceAgeChineseMin = 3;
    const serviceAgeMathMin = 6;
    const serviceAgeEnglishMin = 5;

    if (subject === 'CHINESE') {
      if (serviceAgeChineseMin <= ageNum) {
        return true;
      }
    }
    if (subject === 'MATH') {
      if (serviceAgeMathMin <= ageNum) {
        return true;
      }
    }
    if (subject === 'ENGLISH') {
      if (serviceAgeEnglishMin <= ageNum) {
        return true;
      }
    }
    return false;
  };

  // 海报埋点
  const posterReport = (config: ConfigurationProps) => {
    if (posterId) {
      const posterIdArr = localStorage.getItem('posterIdArr');
      if (posterIdArr && JSON.parse(posterIdArr).indexOf(posterId as never) > -1) return;
      const studentCode = getParameterValues('stu');
      query.code = studentCode;
      const posterParms = {
        posterId,
        data: {
          ...query,
          type: pageName,
          testType: v,
          multipleVersionType: config.quizData?.multipleVersionType || '',
          subject: SUBJECT_MAP_EN[config.quizData?.subject || 'CHINESE'],
          originalUrl: window.location.href,
        },
      };
      sendPosterReportEvent(posterParms).then(() => {
        localStorage.setItem('posterIdArr', JSON.stringify([...(JSON.parse(posterIdArr as string) ?? []), posterId]));
      });
    }
  };

  // 检索ga或fb渠道
  // eslint-disable-next-line consistent-return
  const pixelChannel = (id: any) => {
    if (id === '79ad83aa-a0ab-45c7-addb-8d72f73f318f') {
      return 'GA';
    }
    if (id === '17cd3889-4876-43a8-b3c8-c0f8d08c655d') {
      return 'PIXEL';
    }
    // 喜马拉雅
    if (id === 'ad01e1a2-bd34-42f2-9df9-189d9d579f01') {
      return 'XMLY';
    }
    // pintrk
    if (id === '9289f76b-366d-4ef6-b00c-533125cfcd6c') {
      return 'PINTEREST';
    }
    // Bing
    if (id === '050c24b6-6534-42ba-a39d-7c445aed7a36') {
      return 'BING';
    }
    if (id === 'e631acc0-de40-4185-ae21-57986a2f6513') {
      return 'SHARE_A_SALE';
    }
    if (id === '2b96e9d0-6ecb-4634-8f05-3c33a84c7406') {
      return 'Taboola';
    }
    if (id === 'ea8db6c1-f9b1-4353-8339-c62282d70017') {
      return 'Twitter';
    }
    if (id === 'ce980e9d-6018-4a8e-b301-d764b820b5f3') {
      return 'TikTok';
    }
    return 'other';
  };

  // 广点通埋点，l参数 === 指定l参数
  const getIsGdtParams = () => {
    const isGdt = pixel.channel1 && pixel.trackingCode === 'GDT';
    return GDT_L_PARAMS.includes(l) || isGdt;
  };

  const mergeReportParams = () => {
    reportParams.current = {
      ...reportParams.current,
      ...commonReportParams.current,
    };
  };

  // hack 一下, 前提认为 quizName 和 whenCreated 必定能通过接口拿到
  const doCommonReport = () => {
    const { quizName, whenCreated } = commonReportParams.current;
    if (quizName && whenCreated) {
      mergeReportParams();

      report(
        `${pageName}_${REPORT_PV_RETAINED_CAPITAL}_${l}`,
        {
          ...reportParams.current,
          event: REPORT_PV_RETAINED_CAPITAL,
          pv: 1,
          originalUrl: window.location.href,
        },
        true,
      );

      report(`${pageName}_${REPORT_UV_RETAINED_CAPITAL}_${l}`, {
        ...reportParams.current,
        event: REPORT_UV_RETAINED_CAPITAL,
        uv: 1,
      });

      if (isMobile) {
        doTrack(FIELDS_MAP.MOBILE_LANDING_RESERVE_PV, { ...reportParams.current, pv: 1 }, true);
        doTrack(FIELDS_MAP.MOBILE_LANDING_RESERVE_UV, {
          ...reportParams.current,
          uv: 1,
        });
      } else {
        doTrack(FIELDS_MAP.PC_LANDING_RESERVE_PV, { ...reportParams.current, pv: 1 }, true);
        doTrack(FIELDS_MAP.PC_LANDING_RESERVE_UV, {
          ...reportParams.current,
          uv: 1,
        });
      }
    }
  };

  // 获取l参数配置详情
  useEffect(() => {
    if (l) {
      getJsonNode(l).then((res) => {
        const data = {
          // 这个是什么渠道
          channel1:
            res?.content?.nodeContent?.channel1 === '634a702d-8049-4ea4-ab0e-513d20d27748' ||
            res?.content?.nodeContent?.channel1 === '70c7ecc2-1a58-4946-97c8-9fedf9482339',
          channel2: pixelChannel(res?.content?.nodeContent?.channel2),
          trackingCode: res?.content?.nodeContent?.trackingCode,
        };
        setPixel(data);
        localStorage.setItem('pixel', JSON.stringify(data) || '{}');

        commonReportParams.current = {
          ...commonReportParams.current,
          whenCreated: res?.content?.whenCreated!,
          channel1: res?.content?.nodeContent?.channel1!,
          channel2: res?.content?.nodeContent?.channel2!,
          channel3: res?.content?.nodeContent?.channel3!,
        };
        doCommonReport();

        // gclid
        const code = res?.content?.nodeContent?.trackingCode || '';
        if (code === 'GA') {
          setTrackingCode('Google');
          localStorage.setItem('GCLID', gclid);
          const createGclId = localStorage.getItem('GCLID') || gclid || '';
          setGclId(createGclId);
        }
        if (
          res?.content?.nodeContent?.channel1 === '685a0980-f8e9-4b81-9cfb-60a465914fa2' &&
          res?.content?.nodeContent?.channel2 === 'ce5bfe57-c057-417b-bd18-416834c3cd2e' &&
          code === 'GA'
        ) {
          setOfficialWebsiteGa4(true);
          sessionStorage.setItem('officialWebsiteGa4', JSON.stringify(true));
          if (process.env.NEXT_PUBLIC_GA_ID_NEW) {
            install(process.env.NEXT_PUBLIC_GA_ID_NEW, { groups: 'group1' });
          }
        }
      });
    }
  }, []);

  // 判断是否显示验证码
  useEffect(() => {
    if (
      formTypeConfig.current.freshStudentInfo &&
      studentCode &&
      formCountryCode &&
      iPCode &&
      (configurationActive?.isPhoneVerify || iPCode !== formCountryCode)
    ) {
      setIsPhoneVerify(true);
    }
  }, [configurationActive, iPCode, formCountryCode, studentCode, formTypeConfig]);

  // 通过学号获取学生信息；目前为落地页类型为扩科
  const freshStudentInfo = (config: ConfigurationProps) => {
    // 获取学生信息
    if (studentCode) {
      getStudentInformation({ code: studentCode }).then((data) => {
        setFormDefaultData({
          ...data,
          mail: data?.email || '',
          studentCode,
        });
        setStudentInfo(data);
        if (formTypeConfig.current.useFormDefaultCountryCode) {
          // 如果是86手机号也取86数据
          if (data.countryCode === '+86') {
            handleGetCountry(true);
          }
          const ageOptions = getAgeOptions(config.quizData?.subject || 'CHINESE', config?.quizData?.language || '');
          form.setFieldsValue({
            phone: [data.countryCode, data.phone || '', data.country || ''],
            name: data?.name,
            englishName: data?.englishName,
            studentCode,
            age: ageOptions?.find((item) => item.value === data?.age),
            mail: data?.email,
          });
          setFormCountryCode(data?.countryCode || '');
        }
      });
    }
  };

  useEffect(() => {
    // 由于code参数重名，单独获取url code
    const studentCode = getParameterValues('stu');
    // 通过学号获取中文 数学课时信息
    if (configurationActive?.isCertificateLearning && studentCode) {
      getStudentDayAndClass(studentCode).then((res) => {
        setStudentCourseInfo(res);
      });
    }
    // 打来挽留
    if (configurationActive?.isDetainment) {
      isLeavingRef.current = true;
      // pushHistory();
    }
  }, [configurationActive]);

  // lang值 CH/EN/CH_EN
  // userLanguage 值 zh en 以及其他语言
  const handleConversionLanguage = (lang?: string) => {
    const userDefaultLanguage = getUserDefaultLanguage();
    if (!lang) {
      return 'EN';
    }

    if (lang === 'CH_EN') {
      if (userDefaultLanguage === 'zh') {
        setLanguage('CH');
        setCookie('CH');
        return 'CH';
      }
      setLanguage('EN');
      setCookie('EN');
      return 'EN';
    }
    setLanguage(lang);
    setCookie(lang as 'CH' | 'EN');
    return lang;
  };

  const handleSetConfigurationActive = (value: {
    config: ConfigurationProps;
    useLanguage?: string;
    isMobile?: boolean;
  }) => {
    const isMobileActive = value.isMobile !== undefined ? value.isMobile : isMobile;
    console.log('重新渲染handleSetConfigurationActive-->', value.isMobile);
    // 判断语言是 是否是双语 CH_EN ，双语走判断逻辑
    const defaultLanguage = handleConversionLanguage(value?.config?.quizData?.language || 'EN');
    console.log('defaultLanguage-->', defaultLanguage);
    // 使用英文配置数据 当设置为双语 并且默认语言为英文 才取英文配置数据；其余取默认数据
    let useEnData = value?.config?.quizData?.language === 'CH_EN' && defaultLanguage === 'EN';

    if (value?.useLanguage === 'EN') {
      useEnData = true;
    } else if (value?.useLanguage === 'CH') {
      useEnData = false;
    }

    let configActiveData: ConfigurationPcMobileProps = {};

    const quizData = value?.config?.quizData;
    const mobilDataOg = quizData?.mobil;
    const mobilData = {
      ...quizData?.mobil,
      // 优先去booking二维码 没有取配置的 兼容旧数据
      completionPageQRCode:
        quizData?.booking?.completionPageBookingQRCodeUrl || quizData?.mobil?.completionPageQRCode || '',
      completionPageWriting: quizData?.booking?.completionPageWriting || quizData?.mobil?.completionPageWriting || '',
      rewards: quizData?.booking?.rewards,
      bookingFlow: quizData?.booking?.bookingFlow,
    };
    let pcDataOg = Object.keys((quizData?.pc as object) || {}).length <= 2 ? {} : quizData?.pc;

    const pcData = {
      ...quizData?.pc,
      completionPageQRCode:
        quizData?.booking?.completionPageBookingQRCodeUrl || quizData?.pc?.completionPageQRCode || '',
      completionPageWriting: quizData?.booking?.completionPageWriting || quizData?.pc?.completionPageWriting || '',
      rewards: quizData?.booking?.rewards,
      bookingFlow: quizData?.booking?.bookingFlow,
    };
    const mobileEnData = {
      ...quizData?.mobilEn,
      completionPageQRCode:
        quizData?.bookingEn?.completionPageBookingQRCodeUrl || quizData?.mobilEn?.completionPageQRCode || '',
      completionPageWriting:
        quizData?.bookingEn?.completionPageWriting || quizData?.mobilEn?.completionPageWriting || '',
      rewards: quizData?.bookingEn?.rewards,
      bookingFlow: quizData?.bookingEn?.bookingFlow,
    };
    const pcEnData = {
      ...quizData?.pcEn,
      completionPageQRCode:
        quizData?.bookingEn?.completionPageBookingQRCodeUrl || quizData?.pcEn?.completionPageQRCode || '',
      completionPageWriting: quizData?.bookingEn?.completionPageWriting || quizData?.pcEn?.completionPageWriting || '',
      rewards: quizData?.bookingEn?.rewards,
      bookingFlow: quizData?.bookingEn?.bookingFlow,
    };

    // 移动端 pc 分别取对应数据
    // 更加当前默认语言 取对应数据
    // 如果当前 是双语CH_EN 并且 默认语言是英语 EN 使用 英文数据 mobilEn
    // pc无数据时，用mobile数据，设置当前样式为mobile
    // mobile无数据时，用pc数据，设置当前样式为pc
    // 响应式数据

    console.log('configurationActive isMobile', isMobileActive);

    if (!isEmpty(mobilDataOg) && !isEmpty(pcDataOg)) {
      if (isMobileActive) {
        configActiveData = (useEnData ? mobileEnData : mobilData) || {};
      } else {
        configActiveData = (useEnData ? pcEnData : pcData) || {};
      }
    }
    if (!isEmpty(mobilDataOg) && isEmpty(pcDataOg)) {
      configActiveData = (useEnData ? mobileEnData : mobilData) || {};
      setStyleType('AllMobile');
    }
    if (!isEmpty(pcDataOg) && isEmpty(mobilDataOg)) {
      configActiveData = (useEnData ? pcEnData : pcData) || {};
      setStyleType('AllPC');
    }

    setConfigurationActive(configActiveData);

    // 存储约课需要的配置数据
    const formType = quizData?.formType;
    if (formType === 'BOOKING' || formType === 'CLASS_BOOKING') {
      const bookingData = {
        subject: quizData?.subject || '',
        language: quizData?.language || '',
        booking: quizData?.booking || {},
        bookingEn: quizData?.bookingEn || {},
        isStudentEnName: configActiveData.isStudentEnName || false,
      };
      sessionStorage.setItem('bookingConfiguration', JSON.stringify(bookingData));
    }
  };

  // 如果加载页面后和服务端判断的是否是移动端不匹配那么才重新渲染
  useEffect(() => {
    if (customerIsMobile !== isMobile) {
      setIsMobile(customerIsMobile);
      handleSetConfigurationActive({ config: configuration, isMobile: customerIsMobile });
    }
  }, [customerIsMobile, isMobile]);

  // 吸底按钮 展示隐藏
  useEffect(() => {
    const bannerHeight = bannerRef.current?.clientHeight;
    const handleScroll = () => {
      const sTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      setHideBtn(sTop < (bannerHeight || 700));
      setSideHide(sTop < (bannerHeight || 700));
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  // 埋点上报，新版 sdk
  const handleClickReport = (event: string, extra: { [key: string]: any } = {}) => {
    const data = {
      _event: event,
      L_parameter: l,
      Code: studentCode,
      subject: configuration.quizData?.subject || 'CHINESE',
      abtest_id: v,
      multipleVersionType: configuration.quizData?.multipleVersionType || '',
      type: id,
      ...extra,
    };
    traceEvent({
      data,
    });
  };

  const goStu = (value: { token?: string; studentCode?: string; loadingModal?: any }) => {
    const lang = language === 'CH' ? 'zh' : 'en';
    const createDataSession = JSON.parse(sessionStorage.getItem('createData') || '{}');
    let params = {
      mobile: createDataSession?.mobile,
      countryCode: createDataSession?.countryCode,
      subject: configuration.quizData?.subject,
      accessMode: 'tourist',
      studentCode: value?.studentCode,
    };

    const queryParams: any = {
      token: value?.token || '',
      from: 'landing',
      landing_id: id,
      subject: lowerCase(configuration.quizData?.subject || 'CHINESE'),
    };
    if (!value?.token) {
      queryParams.params = objectToBase64(params);
    }
    window.location.href = qs.stringifyUrl({
      url: `${process.env.NEXT_PUBLIC_STU_CENTER}${lang}/home`,
      query: queryParams,
    });
    value?.loadingModal.hide();
  };

  // 新线索、老线索都可通过可配置落地页跳进完成页
  const jumpResult = async (value?: {
    WXCodeUrl?: string;
    studentCodeBooking?: string;
    trackId?: string;
    phone?: Array<string>;
    email?: string;
    // 是否是全新用户 不包含老线索激活 重复进线
    isNewUser?: boolean;
    studentCode?: string;
    token?: string;
    sign?: string;
    verificationCode?: string;
    loadingModal?: any;
    // 改造逻辑之前isNewUser 为true 才到约课 ，现在留资变为查询是未约课才到约课 isNewUser 和 allowToBooking 为 true 都可以到约课页
    allowToBooking?: boolean;
  }) => {
    handleClickReport(EVENT_NAME_MAP.FIRSTORDER_SUBMITBUTTONLEADSID, {
      track_id: value?.trackId,
    });
    handleClickReport('E_Inline', {
      track_id: value?.trackId,
      isNewLead: value?.isNewUser,
    });
    const serveLanguage = form.getFieldValue('serveLanguage');
    const formType = configuration.quizData?.formType;
    // 保持token
    sessionStorage.setItem('stuToken', value?.token || '');
    const age = form.getFieldValue('age')?.value || '';

    const gotoLandingSuccess = () => {
      const goSuccess = () => {
        const url = '/landing/trialClassResult';
        sessionStorage.setItem(
          'pageConfig',
          JSON.stringify({
            isBooking: false,
            l,
            v,
            multipleVersionType: configuration.quizData?.multipleVersionType || '',
            landingId: id,
            subject: configuration.quizData?.subject,
            // 使用原始语言数据 避免双语失效
            language: configuration.quizData?.language,
            trackId: value?.trackId,
            isNewUser: value?.isNewUser,
            pixelChannel:
              pixel.channel1 &&
              pixel.channel2 === 'SHARE_A_SALE' &&
              pixel.channel2 === pixel.trackingCode &&
              pixel.channel2,
            serveLanguage: serveLanguage?.value || '',
            bindingStudentCenter: configuration.quizData?.bindingStudentCenter,
            bindingStudentCenterType: configuration.quizData?.bindingStudentCenterType,
            booking: configuration?.quizData?.booking || {},
            bookingEn: configuration?.quizData?.bookingEn || {},
            isStudentEnName: configurationActive.isStudentEnName || false,
            formType: configuration?.quizData?.formType,
            completionPageWriting: configurationActive?.completionPageWriting || '',
            completionPageQRCode: configurationActive?.completionPageQRCode || '',
            rewards: configurationActive?.rewards,
            studentCode: value?.studentCodeBooking || value?.studentCode,
          }),
        );
        // }
        router.push(url);
        value?.loadingModal.hide();
      };
      // 串连学员中心
      // if (configuration.quizData?.bindingStudentCenter) {
      //   // 是否有 token sign 没有就获取
      //   if (!value?.token && !value?.sign) {
      //     createTokenSign({
      //       // 验证码
      //       verificationCode: value?.verificationCode,
      //       // Chinese/Math
      //       subject: SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE'],
      //       // 区号
      //       countryCode: fromParams.current?.countryCode,
      //       mobile: fromParams.current?.mobile,
      //       // 国家代码
      //       country: fromParams.current?.country,
      //     })
      //       .then((res) => {
      //         sessionStorage.setItem('stuToken', res?.token || '');
      //         // 自动跳转学员中心 并且是全新用户
      //         if (configuration.quizData?.bindingStudentCenterType === 'auto' && value?.isNewUser) {
      //           goStu({ token: res?.token, studentCode: value?.studentCode, loadingModal: value?.loadingModal });
      //         } else {
      //           // 跳转结果页
      //           goSuccess();
      //         }
      //       })
      //       .catch(() => {
      //         value?.loadingModal.hide();
      //       });
      //     return;
      //   }

      //   if (configuration.quizData?.bindingStudentCenterType === 'auto' && value?.isNewUser) {
      //     goStu({ token: value?.token, studentCode: value?.studentCode, loadingModal: value?.loadingModal });
      //   } else {
      //     goSuccess();
      //   }
      //   if (configuration.quizData?.bindingStudentCenterType === 'button') {
      //     goSuccess();
      //   }
      //   return;
      // }
      goSuccess();
    };

    const gotoBooking = () => {
      const { pvid } = getBasicInfo() as any;
      // 分步骤
      if (configurationActive?.bookingFlow === 'IN_STEPS') {
        // TODO 仅保存需要的
        sessionStorage.setItem(
          'pageConfig',
          JSON.stringify({
            l,
            v,
            multipleVersionType: configuration.quizData?.multipleVersionType || '',
            landingId: id,
            subject: configuration.quizData?.subject,
            // 使用原始语言数据 避免双语失效
            language: configuration.quizData?.language,
            studentCode: value?.studentCodeBooking || value?.studentCode,
            // 约课到结果页的completionPageWriting 不再传入 约课页处理 因为有多语言切换
            // completionPageWriting: bookingConfiguration?.booking?.completionPageWriting,
            // 优先使用配置的 没有配置使用企微 因为有双语切换 默认码切换到约课页传入
            completionPageQRCode: value?.WXCodeUrl || '',
            trackId: value?.trackId,
            isNewUser: value?.isNewUser,
            verificationCode: value?.verificationCode || '',
            verificationCodeUsed: value?.verificationCode ? true : false,
            pixelChannel:
              pixel.channel1 &&
              pixel.channel2 === 'SHARE_A_SALE' &&
              pixel.channel2 === pixel.trackingCode &&
              pixel.channel2,
            serveLanguage: serveLanguage?.value || '',
            bindingStudentCenter: configuration.quizData?.bindingStudentCenter,
            bindingStudentCenterType: configuration.quizData?.bindingStudentCenterType,
            booking: configuration?.quizData?.booking || {},
            bookingEn: configuration?.quizData?.bookingEn || {},
            isStudentEnName: configurationActive.isStudentEnName || false,
            formType: configuration?.quizData?.formType,
            entrance: 'landing',
          }),
        );

        router.push({
          pathname: '/landing/appointmentClass',
          query: { ...router.query, triggerPvid: pvid },
        });
      } else {
        const url = qs.stringifyUrl({
          url: '/landing/ClassChoose',
          query: {
            l,
            v,
            multipleVersionType: configuration.quizData?.multipleVersionType || '',
            landingId: id,
            formSubject: configuration.quizData?.subject,
            // 使用原始语言数据 避免双语失效
            language: configuration.quizData?.language,
            studentCode: value?.studentCodeBooking || value?.studentCode,
            // 约课到结果页的completionPageWriting 不再传入 约课页处理 因为有多语言切换
            // completionPageWriting: bookingConfiguration?.booking?.completionPageWriting,
            // 优先使用配置的 没有配置使用企微 因为有双语切换 默认码切换到约课页传入
            completionPageQRCode: value?.WXCodeUrl || '',
            trackId: value?.trackId,
            isNewUser: value?.isNewUser,
            verificationCode: value?.verificationCode || '',
            verificationCodeUsed: value?.verificationCode ? true : false,
            pixelChannel:
              pixel.channel1 &&
              pixel.channel2 === 'SHARE_A_SALE' &&
              pixel.channel2 === pixel.trackingCode &&
              pixel.channel2,
            serveLanguage: serveLanguage?.value || '',
            bindingStudentCenter: configuration.quizData?.bindingStudentCenter,
            bindingStudentCenterType: configuration.quizData?.bindingStudentCenterType,
            triggerPvid: pvid,
          },
        });
        router.push(url);
      }

      value?.loadingModal.hide();
    };
    // 分步骤 是否可以约课 埋点 classAvailableStatus(1是可约课/0是无可约)
    const handleClickReportSecondOrder = (AvailableStatus: 1 | 0) => {
      if (configurationActive?.bookingFlow === 'IN_STEPS') {
        handleClickReport(`G_NSecondOrder_ReducibleState`, {
          track_id: value?.trackId,
          RepetitionLeads: !value?.isNewUser,
          // 是否可约课
          classAvailableStatus: AvailableStatus,
        });
      }
    };

    // 判断是 已付费用户 提醒已存在；未付费 继续走约课和成功页
    getIsPayingUser({
      studentCode: value?.studentCodeBooking || '',
      subject: capitalize(configuration.quizData?.subject),
    })
      .then((res: any) => {
        //  false: 未付费付费用户 继续走约课和成功页
        if (!res) {
          // 去约课页 isNewUser 是新用户 或者 允许开关是打开的
          if (
            (formType === 'BOOKING' || formType === 'CLASS_BOOKING') &&
            serviceAgeScope({ subject: configuration.quizData?.subject, age }) &&
            (value?.isNewUser || value?.allowToBooking)
          ) {
            if (
              configuration.quizData?.subject === 'CHINESE' ||
              (!form?.getFieldValue('grade')?.value && form?.getFieldValue('grade')?.value !== 0)
            ) {
              // 中文始终有课
              handleClickReportSecondOrder(1);
              gotoBooking();
            } else {
              let data: any = {};
              if (configuration.quizData?.subject === 'MATH') {
                data = {
                  subject: 'Math',
                  timezone: countryData?.timeZone?.itemValue,
                  grade:
                    form?.getFieldValue('grade')?.value || form?.getFieldValue('grade')?.value === 0
                      ? form?.getFieldValue('grade')?.value
                      : '3',
                  country: countryData?.country || '',
                };
              } else if (configuration.quizData?.subject === 'ENGLISH') {
                data = {
                  subject: 'English',
                  timezone: countryData?.timeZone?.itemValue,
                  grade:
                    form?.getFieldValue('grade')?.value || form?.getFieldValue('grade')?.value === 0
                      ? form?.getFieldValue('grade')?.value
                      : '3',
                  country: countryData?.country || '',
                };
              }
              getLessonAvailableDateList(data)
                .then((res) => {
                  // 过滤可选的日期
                  const canDates = res.map(({ localDate }) => localDate);
                  if (canDates.length !== 0) {
                    handleClickReportSecondOrder(1);
                    gotoBooking();
                  } else {
                    handleClickReportSecondOrder(0);
                    gotoLandingSuccess();
                  }
                })
                .catch(() => {
                  value?.loadingModal.hide();
                  submitting.current = false;
                });
            }
          } else {
            gotoLandingSuccess();
            // 年级不符合 也算无课 不可约
            handleClickReportSecondOrder(0);
          }
        } else {
          // true: 已付费用户 已存在
          Toast.info(langText.formInformationExists);
          value?.loadingModal.hide();
          submitting.current = false;
        }
      })
      .catch(() => {
        Toast.info(langText.tryAgain);
        value?.loadingModal.hide();
        submitting.current = false;
      });
  };

  console.log('pixel-->', pixel);

  const handleToTop = () => {
    scrollToTop();
    report(`${pageName}_${REPORT_CLI_IPT_BTN_SUCTION_BOTTOM}_${l}`, {
      ...reportParams.current,
      event: REPORT_CLI_IPT_BTN_SUCTION_BOTTOM,
    });
    doTrackList([FIELDS_MAP.LEVITATION_BUTTON_CLICK, FIELDS_MAP.LEVITATION_BUTTON_CLICK_USER]);
  };

  // 上报GA4事件
  const sendEvent2GA4 = (params: CreateLead) => {
    if (pixel.channel1 && pixel.channel2 === 'GA' && pixel.channel2 === pixel.trackingCode) {
      // vbb 转化事件回传价值
      if (Object.keys(VBB_VALUE_MAP).includes(id)) {
        sendDataToGTM(`${id}_ma_V2_click_complete_ga`, {
          value: params?.age ? FB_VALUE_MAP[params?.age?.toString()] : 0,
          currency: 'USD',
        });
      } else {
        sendDataToGTM(`${id}_ma_V2_click_complete_ga`);
      }
    }
  };
  // 发送提交表单成功埋点 fb google 广点通埋点（2023-2-1） (只要接口成功就触发 埋点 不看重复线索)
  const sendReportComplete = (params: CreateLead) => {
    if (pixel.channel1 && pixel.channel2 === 'PIXEL' && pixel.channel2 === pixel.trackingCode) {
      console.log('fb埋点-->');
      window.fbq(
        'trackSingle',
        '1032673631108666',
        `Purchase`,
        { promotion: 'phone' },
        { eventID: formClickStatusRef.current.phone },
      );
    }
    if (id === 'ST7LRWSx' || id === 'NLwKIJZy') {
      try {
        window.pintrk('track', `pin_可配置落地页_${id}_点击免费领取`);
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
    sendEvent2GA4(params);
    if (pixel.channel1 && pixel.channel2 === 'XMLY' && pixel.channel2 === pixel.trackingCode) {
      // 前端写死 页面id和路径匹配
      switch (id) {
        case 'TfiZYmsb':
          window.xmlyAdLog.track(2, {
            key: '640a08d68f4a44c9b41b821df18f755c',
          });
          break;
        default:
          break;
      }
    }
    if (pixel.channel1 && pixel.channel2 === 'BING' && pixel.channel2 === pixel.trackingCode) {
      window.uetq = window.uetq || [];
      window.uetq.push('event', 'submit_lead_form', {});
    }
    if (pixel.channel1 && pixel.channel2 === 'Taboola' && pixel.channel2 === pixel.trackingCode) {
      window?._tfa?.push({ notify: 'event', name: 'other1', id: 1618542 });
    }
    if (pixel.channel1 && pixel.channel2 === 'Twitter' && pixel.channel2 === pixel.trackingCode) {
      window?.twq('event', 'tw-o6gtr-ohemm', {});
    }
    if (pixel.channel1 && pixel.channel2 === 'TikTok' && pixel.channel2 === pixel.trackingCode) {
      window?.ttq?.track('CompleteRegistration', {
        // tikTok
        contents: [
          {
            content_id: 'CMJRMORC77UF4ULPBOR0', // string. ID of the product. Example: "1077218".
            content_type: 'create', // string. Either product or product_group.
            content_name: 'create_submit', // string. The name of the page or product. Example: "shirt".
          },
        ],
        status: 'submitted', // string. The status of an order, item, or service. Example: "submitted".
      });
    }
    // 微博埋点
    if (pixel.trackingCode === 'WeiBo') {
      const isWeiboMath = configuration.quizData?.subject === 'MATH';
      try {
        window.wbadmt.send({
          eventid: isWeiboMath ? '1298348' : '1298383',
          eventtype: 'form',
          eventvalue: isWeiboMath ? 'weibo_math_留资约课' : 'weibo_chinese_留资约课',
        });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    }
    // 广点通埋点
    if (getIsGdtParams()) {
      try {
        window.gdt('track', 'RESERVATION', { source: '可配置落地页广点通' });
      } catch (e) {
        console.error(e);
      }
    }
    report(
      `${pageName}_g_FirstOrder_language_${l}`,
      {
        ...reportParams.current,
        data: {
          language: language === 'CH' ? 'Chinese' : 'English',
        },
        event: 'g_FirstOrder_language',
      },
      true,
    );
  };

  // 由于新增了拓科+约课功能，当启用该功能时需要设置约课页数据到localStorage
  // 因此把这部分参数提取出来共用
  const createParams = (value: CreateLead) => {
    // 由于code参数重名，单独获取url code
    const studentCode = getParameterValues('stu');
    query.code = studentCode;
    const params: any = {
      timezone: countryData?.timeZone?.itemValue,
      timezoneText: countryData?.timeZone?.itemName,
      country: value.phone?.[2],
      countryCode: value.phone?.[0],
      lead: l || '',
      formId: '',
      email: (value.mail || formDefaultData.email)?.toLowerCase(),
      createFrom: 'h5',
      leadSource: 'h5',
      mobile: value.phone?.[1],
      name: value.name || formDefaultData.name,
      englishName: value.englishName || formDefaultData.englishName,
      userId: '',
      time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
      leadType: SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE'],
      code: value.code || studentCode,
      // 小于3 大于18 传空
      age: (value?.age?.value && (value?.age?.value?.length > 5 ? '' : value?.age?.value)) || formDefaultData.age || '',
      grade: value?.grade?.value || formDefaultData.grade || '',
      adsType: trackingCode,
      adsUniId: gclIdTrunk,
      edmActivityId,
      serveLanguage: value?.serveLanguage?.value || '',
      recommendStudentSId: recommendStudentSId || '',
      assignAccountId: assignAccountId || '',
      lotteryShareId: shareId || '',
      posterId,
      originalUrl: window.location.href,
      isEmail: isAppSource ? false : configurationActive?.isEmail,
      isCode: isAppSource
        ? false
        : (configurationActive?.isPhoneVerify || startPhoneCode !== startPhone) && !isSpecialCode,
      verificationCode: value?.verificationCode || '',
      // 可配置落地页 配置id
      formNum: id,
      mobileVerified: value?.mobileVerified || false,
      payload: {
        ...(getBasicInfo() || {}),
        ...(query || {}),
      },
    };
    fromParams.current = { ...params };
    sessionStorage.setItem('createData', JSON.stringify(params));
    return params;
  };

  const createLead = async (value: CreateLead, loadingModal: any) => {
    const params: any = createParams(value);
    if (configurationActive?.isCustomInput1 && configurationActive?.customInput1Key) {
      const nawCustomInput1Key = configurationActive?.customInput1Key;
      params[nawCustomInput1Key] = value.customInput1Key;
      params.customFields = { [nawCustomInput1Key]: value.customInput1Key };
    }
    if (configurationActive?.isCustomInput2 && configurationActive?.customInput2Key) {
      const nawCustomInput2Key = configurationActive?.customInput2Key;
      params[nawCustomInput2Key] = value.customInput2Key;
      params.customFields = {
        ...(params?.customFields || {}),
        [nawCustomInput2Key]: value.customInput2Key,
      };
    }
    // 无isabtest 标识 改为v为判断是abtest
    if (v) {
      params.testType = v;
    }
    if (configuration.quizData?.multipleVersionType) {
      params.multipleVersionType = configuration.quizData?.multipleVersionType || '';
    }
    const cpUserInfo = JSON.parse(localStorage.getItem('cpUserInfo') || '{}');
    if (cpUserInfo?.unionid) {
      params.unionId = cpUserInfo?.unionid;
    }
    if (cpUserInfo?.openid) {
      params.openId = cpUserInfo?.openid;
    }
    // 不需要重复进线
    params.needValidRepeatLead = false;
    await createLeadNoRemindNew(params)
      .then((res: any) => {
        sendReportComplete(params);
        if (res.success) {
          const handleJumpResult = (JumpResultValue?: { allowToBooking?: boolean }) => {
            const jumpResultFn = (JumpResultFnValue?: { studentCode?: string }) => {
              jumpResult({
                WXCodeUrl: res?.data?.qrCode || '',
                studentCodeBooking: JumpResultFnValue?.studentCode || res?.data?.studentCode || '',
                trackId: res?.data?.trackId,
                phone: value?.phone,
                email: value.mail || formDefaultData.email || '',
                studentCode: JumpResultFnValue?.studentCode || res?.data?.studentCode || '',
                token: res?.token,
                sign: res?.sign,
                verificationCode: value.verificationCode || '',
                loadingModal,
                isNewUser: res.repetitionLead ? false : true,
                allowToBooking: JumpResultValue?.allowToBooking,
              });
            };
            if (!res?.data?.studentCode) {
              getOldUserStudentCode({
                mobile: value?.phone && `${value?.phone?.[0]} ${value?.phone?.[1]}`,
                subject: configuration.quizData?.subject,
              }).then((res1) => {
                jumpResultFn({ studentCode: res1?.studentCode || '' });
              });
            } else {
              jumpResultFn();
            }
          };
          // 查询是否有约课记录 有就去结果页 没有就去约课
          haveAppointmentRecord(res?.data?.trackId)
            .then((appointmentRecordRes) => {
              // true：可以约课
              if (appointmentRecordRes) {
                handleJumpResult({ allowToBooking: true });
              } else {
                handleJumpResult();
              }
            })
            .catch(() => {
              // 查询失败
              loadingModal?.hide();
              submitting.current = false;
            });
        } else {
          Toast.info(res);
          loadingModal?.hide();
          submitting.current = false;
        }
      })
      .finally(() => {
        // 成功失败都调用跳过接口
        if (trackCreateBeforeId) {
          trackCreateBeforeSkip(trackCreateBeforeId);
        }
        // 成功后关闭验证码弹窗 防止再次点击
        handleCloseVerify();
      })
      .catch((err) => {
        const { response } = err;
        const { data = {}, status } = response;
        const { errors, message } = data;
        const errMsg = (errors && errors[Object.keys(errors)[0]]) || message || err.message;
        // 上报表单报错信息
        const newparams = params;
        delete newparams.timezone;
        delete newparams.timezoneText;
        delete newparams.country;
        delete newparams.countryCode;
        delete newparams.lead;
        delete newparams.formId;
        delete newparams.createFrom;
        delete newparams.leadSource;
        delete newparams.userId;
        delete newparams.time;
        delete newparams.leadType;
        delete newparams.mobile;
        report(
          `${pageName}_${REPORT_FERM_WRONGFORM}_${l}`,
          {
            ...reportParams.current,
            event: REPORT_FERM_WRONGFORM,
            leadFail: {
              message: errMsg,
              ...newparams,
              mobile: JSON.stringify(value.phone),
            },
          },
          true,
        );
        handleClickReport(EVENT_NAME_MAP.FIRSTORDER_SUBMITBUTTON_CLICK, {
          button_name: configurationActive?.submitButtonValue,
          error_code: status,
        });
        if (errMsg === 'emailError') {
          Toast.info('请输入您的邮箱');
          setIsEmailInput(true);
          loadingModal?.hide();
          submitting.current = false;
          return;
        }
        if (errMsg === 'codeError') {
          Toast.info('请输入您的验证码');
          setIsPhoneVerify(true);
          loadingModal?.hide();
          submitting.current = false;
          return;
        }
        if (errMsg === 'allError') {
          Toast.info('请填写完整表单');
          setIsEmailInput(true);
          setIsPhoneVerify(true);
          loadingModal?.hide();
          submitting.current = false;
          return;
        }
        // 重复进线
        // 新流程 不会返回重复进线提醒
        // if (messageIsRepeat(errMsg)) {
        //   // if (configuration.quizData?.isOldUser) {
        //   //   Toast.info(langText.formInformationExists);
        //   //   loadingModal?.hide();
        //   //   submitting.current = false;
        //   // }
        //   getOldUserStudentCode({
        //     mobile: value?.phone && `${value?.phone?.[0]} ${value?.phone?.[1]}`,
        //     subject: configuration.quizData?.subject,
        //   }).then((res1) => {
        //     jumpResult({
        //       studentCodeBooking: res1?.studentCode || '',
        //       phone: value?.phone,
        //       studentCode: res1?.studentCode || '',
        //       verificationCode: value.verificationCode || '',
        //       loadingModal,
        //       isNewUser: false,
        //     });
        //   });
        // } else {
        Toast.info(errMsg);
        loadingModal?.hide();
        submitting.current = false;
        // }
      });
  };

  const handleCanCreateLead = (value: { Chinese: boolean; Math: boolean; English: boolean }) => {
    const subject = configuration.quizData?.subject;
    if (subject === 'MATH' && value.Math && !value.Chinese && !value.English) {
      return true;
    }
    if (subject === 'CHINESE' && value.Chinese && !value.Math && !value.English) {
      return true;
    }
    return subject === 'ENGLISH' && value.English && !value.Chinese && !value.Math;
  };

  const createExpandSubjectsLabel = async (value: {
    phone: Array<string>;
    mail: string;
    studentCode?: string;
    age: string;
    englishName: string;
    verificationCode?: string;
  }) => {
    const params: any = {
      leadId: l,
      mobile: value.phone?.[1] || '',
      email: value.mail || '',
      subject: SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE'],
      posterId,
      stuNumber: value.studentCode || '',
      age: value?.age || '',
      englishName: value?.englishName || '',
    };
    // abtest传 testType
    if (v) {
      params.testType = v;
    }
    if (configuration.quizData?.multipleVersionType) {
      params.multipleVersionType = configuration.quizData?.multipleVersionType || '';
    }
    await expandSubjectsLabelNoRemind(params)
      .then((res) => {
        sendReportComplete(params);
        // if (res?.repeat && configuration.quizData?.isOldUser) {
        //   Toast.info(langText.formInformationExists);
        //   LoadingModal.hide();
        //   submitting.current = false;
        // }
        jumpResult({
          phone: value?.phone || '',
          email: value.mail || '',
          studentCode: res?.stuNumber || value.studentCode,
          verificationCode: value.verificationCode || '',
          loadingModal: LoadingModal,
          isNewUser: !res?.repeat,
          trackId: res?.trackId,
          studentCodeBooking: res?.stuNumber || value.studentCode,
        });
      })
      .catch((err) => {
        const { response } = err;
        const { data = {} } = response;
        const { errors, message } = data;
        const errMsg = (errors && errors[Object.keys(errors)[0]]) || message || err.message;
        // 上报表单报错信息
        report(
          `${pageName}_${REPORT_FERM_WRONGFORM}_${l}`,
          {
            ...reportParams.current,
            event: REPORT_FERM_WRONGFORM,
            leadFail: {
              message: err.message,
              ...params,
              mobile: JSON.stringify(value.phone),
            },
          },
          true,
        );
        Toast.info(errMsg);
        LoadingModal.hide();
        submitting.current = false;
      });
  };

  const createOpenClass = async (value: CreateLead, loadingModal: any) => {
    const params: any = createParams(value);
    if (configurationActive?.isCustomInput1 && configurationActive?.customInput1Key) {
      const nawCustomInput1Key = configurationActive?.customInput1Key;
      params[nawCustomInput1Key] = value.customInput1Key;
      params.customFields = { [nawCustomInput1Key]: value.customInput1Key };
    }
    if (configurationActive?.isCustomInput2 && configurationActive?.customInput2Key) {
      const nawCustomInput2Key = configurationActive?.customInput2Key;
      params[nawCustomInput2Key] = value.customInput2Key;
      params.customFields = {
        ...(params?.customFields || {}),
        [nawCustomInput2Key]: value.customInput2Key,
      };
    }
    params.subject = SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE'];
    // 是否允许重复进线
    params.needValidRepeatLead = configuration.quizData?.isOldUser;
    params.mobile = `${value?.phone[0]} ${value?.phone[1]}`;
    params.payload = JSON.stringify({
      ...(getBasicInfo() || {}),
      ...(router.query || {}),
    });
    // abtest传 testType
    if (v) {
      params.testType = v;
    }
    if (configuration.quizData?.multipleVersionType) {
      params.multipleVersionType = configuration.quizData?.multipleVersionType || '';
    }
    await createOpenClassLead(params)
      .then((res) => {
        sessionStorage.setItem(
          'openClassLeadRes',
          JSON.stringify({
            ...res.content,
          }),
        );
        console.log('res', res);
        handleClickReport('E_Inline', {
          track_id: res?.content?.trackId,
          isNewLead: !res.content.leadRepeat,
        });
        // jumpResult({
        //   phone: value?.phone || '',
        //   email: value?.mail || res.content?.email,
        //   studentCode: res.content.studentCode || '',
        //   verificationCode: value.verificationCode || '',
        //   loadingModal: loadingModal,
        //   isNewUser: !res.content.leadRepeat,
        //   trackId: res?.content?.trackId,
        //   hasNormalCourses: res?.content?.hasNormalCourses,
        //   hasSignUp: res?.content?.hasSignUp,
        // });

        // if (formType === 'PUBLIC_CLASS_BOOKING') {
        // 已约课

        const goOpenClass = (type: 'openClass' | 'openClassResults') => {
          const serveLanguage = form.getFieldValue('serveLanguage');
          sessionStorage.setItem(
            'pageConfig',
            JSON.stringify({
              subject: configuration.quizData?.subject,
              language: configuration?.quizData?.language,
              completionPageWriting: configurationActive?.completionPageWriting || '',
              completionPageQRCode: configurationActive?.completionPageQRCode || '',
              rewards: configurationActive?.rewards,
              trackId: res?.content?.trackId,
              isNewUser: !res.content.leadRepeat,
              pixelChannel:
                pixel.channel1 &&
                pixel.channel2 === 'SHARE_A_SALE' &&
                pixel.channel2 === pixel.trackingCode &&
                pixel.channel2,
              studentCode: res.content.studentCode,
              serveLanguage: serveLanguage?.value || '',
              bindingStudentCenter: configuration.quizData?.bindingStudentCenter,
              bindingStudentCenterType: configuration.quizData?.bindingStudentCenterType,
              landingId: id,
              courseData: configuration.quizData?.courseData,
              relatedLessons: configuration.quizData?.relatedLessons,
              hasNormalCourses: res?.content?.hasNormalCourses && res?.content?.stuCourseResult,
              timezone: countryData?.timeZone?.itemValue,
              timezoneText: countryData?.timeZone?.itemName,
              complementClassTimeCn: res?.content?.stuCourseResult?.complementClassTimeCn,
              complementClassTimeEn: res?.content?.stuCourseResult?.complementClassTimeEn,
              duration: res?.content?.stuCourseResult?.duration,
              daysLater: res?.content?.stuCourseResult?.daysLater,
              classTimeStart: res?.content?.stuCourseResult?.classTimeStart,
              classTimeEnd: res?.content?.stuCourseResult?.classTimeEnd,
              courseId: res?.content?.stuCourseResult?.courseId,
              weekCn: res?.content?.stuCourseResult?.weekCn,
              weekEn: res?.content?.stuCourseResult?.weekEn,
              verificationCodeUsed: value?.verificationCode ? true : false,
              verificationCode: value.verificationCode || '',
              hasSignUp: res?.content?.hasSignUp,
              daysLaterType: res?.content?.daysLaterType,
              l,
              entrance: 'landing',
            }),
          );
          if (type === 'openClass') {
            const { pvid } = getBasicInfo() as any;
            router.push({
              pathname: '/landing/openClass',
              query: { ...router.query, triggerPvid: pvid },
            });
          }
          if (type === 'openClassResults') {
            router.push('/landing/publicClass/result');
          }
          submitting.current = false;
          loadingModal.hide();
        };
        handleClickReport('G_OpenClasses_BookingState', {
          Course_type: '公开课',
          student_state: res?.content?.hasSignUp ? 'already' : 'normal',
          class_state: res?.content?.hasNormalCourses ? 'normal' : 'FULL',
          RepetitionLeads: res.content.leadRepeat,
          track_id: res?.content?.trackId,
        });
        // 已约课
        if (res?.content?.hasSignUp) {
          goOpenClass('openClassResults');
          // 有课
        } else if (res?.content?.hasNormalCourses) {
          goOpenClass('openClass');
        } else {
          // 没有课
          goOpenClass('openClassResults');
        }
      })
      .catch(() => {
        LoadingModal.hide();
        loadingModal.hide();
        submitting.current = false;
      });
  };

  const isValidPhone = () => {
    const formTypeClass = configuration?.quizData?.formType;
    let isFormClassBooking: boolean = true;
    // 拓科+约课
    if (formTypeClass === 'CLASS' || formTypeClass === 'CLASS_BOOKING') {
      isFormClassBooking = false;
    }
    if ((formTypeClass === 'BOOKING' || formTypeClass === 'FORM') && type) {
      isFormClassBooking = false;
    }
    return !(
      isFormClassBooking &&
      (twillio || twillioResponse) &&
      twillioCheckingRef.current === TwilloCheckingStatus.ERROR
    );
  };

  const handleFinishBefore = (values: FormValues) => {
    if (
      !checkedRef.current &&
      configurationActive?.isPrivacyAgreement &&
      configurationActive?.isPrivacyAgreementUserDecideForOneself
    ) {
      setCheckedError(true);
      return;
    }
    if (!isValidPhone()) {
      return;
    }
    setFormValues(values);
    const windowWidth = window.innerWidth;
    if (windowWidth >= 720) {
      setVerifyModalVisible(true);
      return;
    }
    if (windowWidth < 720) {
      setVerifyDrawerVisible(true);
    }
  };

  const handleFinishAfter = async (verificationInfo: VerificationInfo, values?: FormValues) => {
    const value = (values || formValues) as FormValues;
    const loadingModal = verificationInfo?.loadingModal || LoadingModal;
    if (!isValidPhone()) {
      return;
    }
    doTrackList([FIELDS_MAP.SUBMIT_BUTTON_CLICK, FIELDS_MAP.SUBMIT_BUTTON_CLICK_USER]);
    handleClickReport(EVENT_NAME_MAP.FIRSTORDER_SUBMITBUTTON_CLICK, {
      button_name: configurationActive?.submitButtonValue,
    });
    const GTMTriggerOptions = {
      pageId: id,
      version: 'v1',
      formType: 'submit',
      target: 'ads',
    };
    const broadCastParams = {
      mobile: value.phone?.[1],
      countryCode: value.phone?.[0],
      email: (value.mail || formDefaultData.email)?.toLowerCase(),
      country: value.phone?.[2],
    };
    broadcastGTM(broadCastParams, GTMTriggerOptions, pixel);
    const tagValues: { email?: string; phone_number?: string } = {};
    if (value.mail || formDefaultData.email) {
      tagValues.email = (value.mail || formDefaultData.email)?.toLowerCase();
    }
    if (value?.phone?.[1]) {
      tagValues.phone_number = `${value?.phone?.[0]}${value?.phone?.[1]}`;
    }
    // window?.gtag?.('set', 'user_data', tagValues);
    // window?.gtag?.('event', 'form_submit', { send_to: 'AW-435043001' });
    // // vbb 转化事件回传价值
    // if (Object.keys(VBB_VALUE_MAP).includes(id)) {
    //   window?.gtag('event', 'conversion', {
    //     send_to: `AW-435043001/${VBB_VALUE_MAP[id]}`,
    //     value: FB_VALUE_MAP[value?.age?.value] || 0,
    //     currency: 'USD',
    //   });
    // }
    // 如果是中文科目，fb pixel 回传价值转化 https://www.facebook.com/business/help/392174274295227?id=1205376682832142

    if (
      pixel.channel1 &&
      pixel.channel2 === 'PIXEL' &&
      pixel.channel2 === pixel.trackingCode &&
      configuration?.quizData?.subject === 'CHINESE'
    ) {
      sendDataToGTM(`all_product_ec_v1_submit_complete_ads`, {
        value: FB_VALUE_MAP[value?.age?.value] || 0,
      });
    }
    if (submitting.current) {
      Toast.info(langText.Submitting);
      return;
    }
    if (
      !checked &&
      configurationActive?.isPrivacyAgreement &&
      configurationActive?.isPrivacyAgreementUserDecideForOneself
    ) {
      loadingModal.hide();
      setCheckedError(true);
      return;
    }
    submitting.current = true;
    if (!verificationInfo?.loadingModal) {
      loadingModal.show(langText.loading);
    }
    report(`${pageName}_${REPORT_CLI_IPT_BTN_GET}_${l}`, {
      ...reportParams.current,
      event: REPORT_CLI_IPT_BTN_GET,
    });
    const { phone, name, englishName, mail, customInput1Key, customInput2Key, age, serveLanguage, grade } = value;
    const formType = configuration.quizData?.formType;

    // 使用默认创建线索接口
    if (formTypeConfig.current.useDefaultCreate) {
      createLead(
        {
          phone,
          name,
          englishName,
          mail,
          customInput1Key,
          customInput2Key,
          age,
          grade,
          serveLanguage,
          verificationCode: verificationInfo?.verificationCode,
          mobileVerified: verificationInfo?.mobileVerified,
        },
        loadingModal,
      );
    }
    // 使用扩科流程
    // 【数学】 扩科为例：
    // 判断手机号和返回的手机号是否一致
    // 一致：数学扩科，打标签接口
    // 不一致：查询是否是新老线索：
    // Chinese Math 都为false， 进数学新线索
    // Chinese Math 都是true 进 ，激活数学 打标签接口
    // Chinese 为true，Math 为 false 数学扩科，打标签接口
    // Chinese 为false，Math 为 true， 进数学激活，线索接口
    if (formTypeConfig.current.useExpandSubjectsLabel) {
      // 如果是拓科+约课，需要将数据设置到localStorage供约课页反显
      if (formType === 'CLASS_BOOKING') {
        createParams({
          phone,
          name,
          englishName,
          mail,
          customInput1Key,
          customInput2Key,
          age,
          serveLanguage,
          mobileVerified: verificationInfo?.mobileVerified,
        });
      }
      if (studentInfo.phone === value.phone?.[1]) {
        createExpandSubjectsLabel({
          phone,
          mail,
          studentCode,
          age: age?.value,
          englishName,
          verificationCode: verificationInfo?.verificationCode,
        });
      } else {
        getClueTrackInfo({
          mobile: `${value.phone?.[1]}`,
          email: mail || '',
        }).then((res) => {
          // Chinese Math 都为false， 进新线索
          if (!res.Math && !res.Chinese && !res.English) {
            createLead(
              {
                phone,
                name,
                englishName,
                mail,
                customInput1Key,
                customInput2Key,
                code: studentCode,
                serveLanguage,
                verificationCode: verificationInfo?.verificationCode,
                mobileVerified: verificationInfo?.mobileVerified,
              },
              loadingModal,
            );
          } else if (handleCanCreateLead(res)) {
            // 当前科目为true，另外科目为false 进线索 激活
            createLead(
              {
                phone,
                name,
                englishName,
                mail,
                customInput1Key,
                customInput2Key,
                serveLanguage,
                verificationCode: verificationInfo?.verificationCode,
                mobileVerified: verificationInfo?.mobileVerified,
              },
              loadingModal,
            );
          } else {
            // 其他情况打标签
            createExpandSubjectsLabel({
              phone,
              mail,
              age: age?.value,
              englishName,
              verificationCode: verificationInfo?.verificationCode,
            });
          }
        });
      }
    }
    // 公开课流程
    if (formTypeConfig.current.useOpenClassCreate) {
      createOpenClass(
        {
          phone,
          name,
          englishName,
          mail,
          customInput1Key,
          customInput2Key,
          age,
          grade,
          serveLanguage,
          verificationCode: verificationInfo?.verificationCode,
          mobileVerified: verificationInfo?.mobileVerified,
        },
        loadingModal,
      );
    }
  };

  const handleFinishDebounce = async (values: FormValues, times = 1) => {
    if (submitting.current) {
      Toast.info(langText.Submitting);
      return;
    }
    // 验证 twillio 校验是否完成
    if (twillioCheckingRef.current === TwilloCheckingStatus.WAITING) {
      if (times === 1) {
        LoadingModal.show(langText.loading);
      }
      await new Promise((resolve) => {
        setTimeout(resolve, 200);
      });
      handleFinishDebounce(values, times + 1);
      return;
    }
    LoadingModal.hide();
    // 如果需要验证码校验，先处理验证码逻辑
    if (isPhoneVerify || values.phone?.[0] !== iPCode) {
      handleFinishBefore(values);
      return;
    }
    handleFinishAfter({}, values);
  };

  const handleFinish = debounce(handleFinishDebounce, 1000, {
    leading: true, // 立即执行
  });

  // 需求：点击各个输入框，只执行一次埋点； 点击form 里面input的点击的placeholder 判断input是否被上传过事件 没有就执行上传ga 然后改变状态
  // TODO 修改判断方式
  const handleFormClick = (event: React.MouseEvent) => {
    const target = event.target as HTMLInputElement | undefined;
    if (target) {
      if (target?.type === 'tel') {
        if (!formClickStatusRef.current.phone) {
          report(`${pageName}_${REPORT_CLI_IPT_PHONE}_${l}`, {
            ...reportParams.current,
            event: REPORT_CLI_IPT_PHONE,
          });
          formClickStatusRef.current.phone = true;
        }
        if (pixel.channel1 && pixel.channel2 === 'PIXEL' && pixel.channel2 === pixel.trackingCode) {
          window.fbq(
            'trackSingle',
            '1032673631108666',
            `${id}_ma_V2_click_phone_fb`,
            { promotion: 'phone' },
            { eventID: formClickStatusRef.current.phone },
          );
        }
        if (id === 'ST7LRWSx' || id === 'NLwKIJZy') {
          try {
            window.pintrk('track', `pin_可配置落地页_${id}_提交手机`);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
        if (pixel.channel1 && pixel.channel2 === 'GA' && pixel.channel2 === pixel.trackingCode) {
          sendDataToGTM(`${id}_ma_V2_click_phone_ga`);
        }
      } else if (target?.name === 'mail') {
        if (!formClickStatusRef.current.mail) {
          report(`${pageName}_${REPORT_CLI_IPT_MAIL}_${l}`, {
            ...reportParams.current,
            event: REPORT_CLI_IPT_MAIL,
          });
          formClickStatusRef.current.mail = true;
        }
      } else if (target?.name === 'name') {
        if (!formClickStatusRef.current.name) {
          report(`${pageName}_${REPORT_CLI_IPT_NAME}_${l}`, {
            ...reportParams.current,
            event: REPORT_CLI_IPT_NAME,
          });
          formClickStatusRef.current.name = true;
        }
      } else if (target?.name === 'englishName') {
        if (!formClickStatusRef.current.englishName) {
          report(`${pageName}_${REPORT_CLI_IPT_NAME}_${l}`, {
            ...reportParams.current,
            event: REPORT_CLI_IPT_ENGLISH_NAME,
          });
          formClickStatusRef.current.englishName = true;
        }
      }
    }
  };

  const handlePageInfo = async (config: ConfigurationProps) => {
    // 判断是否是多版本表单
    // 是需要去调用ip接口 修改数据
    if (config?.quizData?.multipleVersionsForms) {
      const showChinaDomestic = await getMultipleVersionType();

      // 根据 showChinaDomestic 的值来设置 updatedQuizData
      const updatedQuizData = showChinaDomestic ? { ...config.exclusiveQuizData } : { ...config.universalQuizData };

      // 更新 config?.quizData 属性值
      config.quizData = {
        ...config.quizData,
        ...updatedQuizData,
        showChinaDomestic,
        // 使用的多版本id
        multipleVersionType: showChinaDomestic ? config.quizData?.exclusiveId : config.quizData?.universalId,
      };

      // 将 config 设置回状态
      setConfiguration(config);
    }

    // 处理 当前 使用 配置数据 是 移动端、pc、双语
    handleSetConfigurationActive({ config });

    formTypeConfig.current = FORM_TYPE_CONFIG[config?.quizData?.formType || 'DEFAULT'] || {};
    if (formTypeConfig.current.freshStudentInfo) {
      freshStudentInfo(config);
    }

    const ga4Id = specialPageIds.has(id)
      ? process.env.NEXT_PUBLIC_GA_ADS_ID
      : GA4_IDS_MAP[config.quizData?.subject as 'CHINESE' | 'MATH' | 'ENGLISH'] || process.env.NEXT_PUBLIC_GA_ADS_ID;

    // 初始化GA4配置
    window.dataLayer = window.dataLayer || [];
    (window.dataLayer as any[]).push({
      event: 'initializeGA4',
      subject: window.subject,
      ga4Id: ga4Id,
    });

    // 海报埋点
    posterReport(config);
    // pv uv埋点
    if (id && config.quizData?.subject) {
      reportParams.current = {
        ...reportParams.current,
        l,
        subject: config.quizData?.subject || 'CHINESE',
        landingPageVersion: pageName,
        pv: null,
        uv: null,
        testType: v || null,
        multipleVersionType: config.quizData?.multipleVersionType || '',
      };

      commonReportParams.current = {
        ...commonReportParams.current,
        quizName: config.quizName!,
      };
      doCommonReport();
      handleGetCountry(config?.quizData?.showChinaDomestic);
      handleClickReport('G_ScanCode_LandingPageView', {
        ocr: ocrCode,
        multipleVersionType: config.quizData?.multipleVersionType || '',
        subject: config.quizData?.subject,
      });
    }
  };

  const freshPageInfo = async () => {
    let pageId = id;
    // abtest 取v的版本号做为id查询数据
    if (v) {
      pageId = v;
      return getConfigurable({ id: pageId }).then((config) => {
        setConfiguration(config);
        handlePageInfo(config);
      });
    }
    // 服务端获取失败情况 可客户端获取
    if (isEmpty(configurationOriginalData)) {
      return getConfigurable({ id: pageId }).then((config) => {
        setConfiguration(config);
        handlePageInfo(config);
      });
    } else {
      // 后台未更新的问题 不知道为什么 公开课的表单 configurationOriginalData有数据 但是 configuration 为空 占时保存一下
      setConfiguration(configurationOriginalData);
    }
    // 默认的就不用了把 服务端转换了 不会部分数据需要处理
    // handlePageInfo(configurationOriginalData);
    handleSeverDataInit(configurationOriginalData);
    return true;
  };
  const handleSeverDataInit = async (config: ConfigurationProps) => {
    formTypeConfig.current = FORM_TYPE_CONFIG[config?.quizData?.formType || 'DEFAULT'] || {};
    if (formTypeConfig.current.freshStudentInfo) {
      freshStudentInfo(config);
    }

    // 存储约课需要的配置数据
    const formType = config?.quizData?.formType;
    if (formType === 'BOOKING' || formType === 'CLASS_BOOKING') {
      const bookingData = {
        subject: config?.quizData?.subject || '',
        language: config?.quizData?.language || '',
        booking: config?.quizData?.booking || {},
        bookingEn: config?.quizData?.bookingEn || {},
        isStudentEnName: configurationActive.isStudentEnName || false,
      };
      sessionStorage.setItem('bookingConfiguration', JSON.stringify(bookingData));
    }

    const ga4Id = specialPageIds.has(id)
      ? process.env.NEXT_PUBLIC_GA_ADS_ID
      : GA4_IDS_MAP[config.quizData?.subject as 'CHINESE' | 'MATH' | 'ENGLISH'] || process.env.NEXT_PUBLIC_GA_ADS_ID;

    // 初始化GA4配置
    window.dataLayer = window.dataLayer || [];
    (window.dataLayer as any[]).push({
      event: 'initializeGA4',
      subject: window.subject,
      ga4Id: ga4Id,
    });

    // 海报埋点
    posterReport(config);
    // pv uv埋点
    if (id && config.quizData?.subject) {
      reportParams.current = {
        ...reportParams.current,
        l,
        subject: config.quizData?.subject || 'CHINESE',
        landingPageVersion: pageName,
        pv: null,
        uv: null,
        testType: v || null,
        multipleVersionType: config.quizData?.multipleVersionType || '',
      };

      commonReportParams.current = {
        ...commonReportParams.current,
        quizName: config.quizName!,
      };
      doCommonReport();
      handleGetCountry(config?.quizData?.showChinaDomestic);
      handleClickReport('G_ScanCode_LandingPageView', {
        ocr: ocrCode,
        multipleVersionType: config.quizData?.multipleVersionType || '',
        subject: config.quizData?.subject,
      });
    }
  };

  // 上报 表单验证失败
  const handleModalFinishFailed = (e: any) => {
    report(
      `${pageName}_${REPORT_FERM_WRONGFORM}_${l}`,
      {
        ...reportParams.current,
        event: REPORT_FERM_WRONGFORM,
        leadFail: {
          message: JSON.stringify(e?.errorFields[0]?.errors),
          ...e?.values,
          phone: JSON.stringify(e?.values?.phone),
        },
      },
      true,
    );
  };

  useAsync(async () => {
    if (id) {
      await Promise.all([freshPageInfo()]);
      setLoadingPlaceholder(false);
    }
  }, [id]);

  useAsync(async () => {
    if (language === 'EN') {
      setLangText(LANDING_CONFIGURABLE_EN);
    } else {
      setLangText(LANDING_CONFIGURABLE_ZH);
    }
  }, [language]);

  // 需要等待页面接口调取完之后(landingPageVersion 名称不带 undefined) 再触发加载时间
  useEffect(() => {
    const { landingPageVersion } = reportParams.current;
    const { whenCreated, quizName } = commonReportParams.current;
    const canReport =
      time && Object.keys(time).length !== 0 && !/undefined/.test(landingPageVersion) && whenCreated && quizName;
    // 上报加载时间
    if (canReport) {
      report(
        `${pageName}_${REPORT_LOAD_TIME}_${l}`,
        {
          ...reportParams.current,
          event: REPORT_LOAD_TIME,
          loadTime: time,
          uv: null,
        },
        true,
      );
    }
  }, [time, reportParams.current]);

  useEffect(() => {
    if (analyse) {
      report(
        `${pageName}_${REPORT_PAGE_PERFORMANCE}_${l}`,
        {
          ...reportParams.current,
          event: REPORT_PAGE_PERFORMANCE,
          data: {
            performance: {
              ...analyse,
            },
          },
        },
        true,
      );
      handleClickReport(EVENT_NAME_MAP.G_LOADING, {
        performance: {
          ...analyse,
        },
      });
      // https://project.feishu.cn/innovation-rd/story/detail/4418649980
      const data = {
        _event: 'G_PageLanguag',
        L_parameter: l,
        subject: configuration.quizData?.subject || 'CHINESE',
        language,
      };
      traceEvent({
        data,
      });
    }
  }, [analyse]);

  const appSubmit = () => {
    if (form) {
      // const { email, name, phone, countryCode, studentCode } = await form.getFieldValue() || {};
      const email = form.getFieldValue('email');
      const name = form.getFieldValue('name');
      const englishName = form.getFieldValue('englishName');
      const phone = form.getFieldValue('phone');
      const studentCode = form.getFieldValue('studentCode');
      const grade = form.getFieldValue('grade');
      handleFinish({
        phone: phone,
        name,
        englishName,
        mail: email,
        code: studentCode,
        customInput1Key: '',
        customInput2Key: '',
        age: {
          value: '',
        },
        grade: {
          value: '',
        },
      });
    }

    doTrackList([FIELDS_MAP.APP_SOURCE_SUBMIT_BUTTON_CLICK, FIELDS_MAP.APP_SOURCE_SUBMIT_BUTTON_CLICK_USER]);
  };

  const handlePhoneInputOnBlur = async () => {
    // 判断当前是否需要前置进线
    // 判断手机号验证是否通过 并且存在手机号
    // 调用前置进线接口
    // 存储返回id
    // 进线后 id去调用跳过已提交的数据接口
    const formValue = await form.validateFields(['phone']);

    // 关闭前置进线
    // if (configuration.quizData?.isFrontIncomingLine) {
    //   if (formValue.phone) {
    //     const params: any = {
    //       timezone: countryData?.timeZone?.itemValue,
    //       timezoneText: countryData?.timeZone?.itemName,
    //       country: formValue.phone?.[2],
    //       countryCode: formValue.phone?.[0],
    //       lead: l || '',
    //       formId: '',
    //       createFrom: 'h5',
    //       leadSource: 'h5',
    //       mobile: formValue.phone?.[1],
    //       userId: '',
    //       time: dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    //       leadType: SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE'],
    //       code,
    //       adsType: trackingCode,
    //       adsUniId: gclIdTrunk,
    //       edmActivityId,
    //       recommendStudentSId: recommendStudentSId || '',
    //       assignAccountId: assignAccountId || '',
    //       lotteryShareId: shareId || '',
    //       posterId,
    //       originalUrl: window.location.href,
    //       payload: getBasicInfo() || {},
    //     };
    //     trackCreateBefore(params).then((res) => {
    //       setTrackCreateBeforeId(res.content);
    //       // 触发发前置进线的话，也上报一次 ga4 事件，避免 ga4 丢失该转化事件
    //       // PS： 是否成功进线属于后台逻辑，此处无法真实判断是否会成功进线， 因为可能会存在 ga4 事件虚高的情况
    //       sendEvent2GA4(params);
    //     });
    //   }
    // }
    twillioCheckingRef.current = TwilloCheckingStatus.WAITING;

    if (configurationActive?.isEmail && formValue.phone?.[1] && formValue.phone?.[1].length > 4) {
      setIsEmailInput(true);
    }
    // twilio 校验，添加埋点
    phoneTwilioIsVerify(formValue.phone?.[0], formValue.phone?.[1])
      .then((val) => {
        report(
          `${pageName}_g_leadVerification_${l}`,
          {
            ...reportParams.current,
            event: 'g_leadVerification',
            data: {
              phone: formValue.phone?.[1],
              areaCode: formValue.phone?.[0],
              verification: val,
            },
          },
          true,
        );
        setTwillioResponse(false);
        setTwillio(!val);
        twillioCheckingRef.current = val ? TwilloCheckingStatus.SUCCESS : TwilloCheckingStatus.ERROR;
      })
      .catch(() => {
        twillioCheckingRef.current = TwilloCheckingStatus.ERROR;
      });

    doTrackList([FIELDS_MAP.PHONE_CLICK, FIELDS_MAP.PHONE_CLICK_USER]);
  };

  const cu: { [key: string]: number } = {
    MATH: studentCourseInfo?.usedMathCu || -1,
    CHINESE: studentCourseInfo?.usedChineseCu || -1,
    ENGLISH: studentCourseInfo?.useEnglishCu || -1,
  };

  const certificateLearningHtml = () => {
    // 课时
    const usedCu = cu[configuration?.quizData?.subject || 'CHINESE'];
    if (configurationActive?.isCertificateLearning) {
      return (
        <div className={styles.certificateLearningBox}>
          <div className={styles.certificateLearning}>
            {language === 'EN' ? (
              <div className={styles.certificateLearningCon}>
                <div className={styles.certificateLearningStudentName}>
                  Dear {studentCourseInfo?.chineseName?.slice(0, 1)}**
                </div>
                {(usedCu || 0) < 5 ? (
                  <div className={styles.certificateLearningInfoTips}>
                    after joining WuKong, you have improved
                    <span> {SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE']} </span>
                    proficiency beyond
                    <span className={styles.certificateLearningInfoTipsBold}> 98.93% </span> of your peers. A special
                    certificate is issued to you as encouragement.
                  </div>
                ) : (
                  <div className={styles.certificateLearningInfoTips}>
                    you have joined WuKong for
                    <span> {studentCourseInfo?.date || 0} </span>
                    days,have studied
                    <span> {usedCu || 0} </span>sessions, and have improved
                    <span> {SUBJECT_MAP_EN[configuration.quizData?.subject || 'CHINESE']} </span>
                    proficiency beyond
                    <span className={styles.certificateLearningInfoTipsBold}> 98.93% </span>
                    of your peers. A special certificate is issued to you as encouragement.
                  </div>
                )}
              </div>
            ) : (
              <div className={styles.certificateLearningCon}>
                <div className={styles.certificateLearningStudentName}>
                  {studentCourseInfo?.chineseName?.slice(0, 1)}**宝贝
                </div>
                {(usedCu || 0) < 5 ? (
                  <div className={styles.certificateLearningInfoTips}>
                    加入悟空, {SUBJECT_MAP_ZH[configuration.quizData?.subject || 'CHINESE']}
                    进步速度远超
                    <span className={styles.certificateLearningInfoTipsBold}>98.93%</span>
                    同龄学员。特发证书，以资鼓励。
                  </div>
                ) : (
                  <div className={styles.certificateLearningInfoTips}>
                    已加入悟空{studentCourseInfo?.date || 0}天，已学习
                    {usedCu || 0}
                    节课，
                    {SUBJECT_MAP_ZH[configuration.quizData?.subject || 'CHINESE']}
                    能力进步超
                    <span className={styles.certificateLearningInfoTipsBold}>98.93%</span>
                    的同龄学员。
                  </div>
                )}
              </div>
            )}

            <img
              className={styles.certificateLearningBg}
              src={configurationActive?.certificateLearningUrlLink}
              alt=""
            />
          </div>
        </div>
      );
    }
    return null;
  };

  const topTipsCon = () => {
    if (configurationActive?.isHorseRaceLamp) {
      // 距离上部位置 Allpc 不使用用， AllMobile pc使用px 移动使用vmin，AllMobile pc使用px 移动使用vmin

      let top = '';
      if (styleType === 'pcMobile') {
        if (isMobile) {
          top = `${pxConversionVMin(Number(configurationActive?.horseRaceLampDistance) / 2 || 128)}vmin`;
        }
      }
      if (styleType === 'AllMobile') {
        if (isMobile) {
          top = `${pxConversionVMin(Number(configurationActive?.horseRaceLampDistance) / 2 || 128)}vmin`;
        } else {
          top = `${Number(configurationActive?.horseRaceLampDistance) / 2 || 128}px`;
        }
      }
      return (
        <div className={classNames(styles.topTips)} style={{ top }}>
          <TopTips
            lotteryBarrage={lotteryBarrage}
            language={language}
            text={configurationActive?.horseRaceLampWorld}
            styleType={styleType}
          />
        </div>
      );
    }
    return null;
  };

  // 打开挽留
  const detainmentOpen = () => {
    setDetainmentVisible(true);
    report(`${pageName}_g_RetainPop_UV_${l}`, {
      ...reportParams.current,
      event: 'g_RetainPop_UV',
    });

    report(
      `${pageName}_g_RetainPop_PV_${l}`,
      {
        ...reportParams.current,
        event: 'g_RetainPop_PV',
      },
      true,
    );
  };

  // 打开挽留 关闭返回路径的弹窗
  const detainmentOpenCloseRouter = () => {
    if (isLeavingRef.current) {
      detainmentOpen();
      isLeavingRef.current = false;
    }
  };
  // 挽留逻辑
  useEffect(() => {
    // console.log('挽留逻辑');
    if (configurationActive?.isDetainment) {
      // console.log('触发 路径跳转');
      window.history.pushState(null, '', document.URL);
    }
    const handlePopState = (event: PopStateEvent) => {
      if (configurationActive?.isDetainment && event.state && isLeavingRef.current) {
        // console.log('触发 监听');
        const state = {
          isWillLeave: true,
        };
        detainmentOpen();
        window.history.pushState(state, '', document.URL);
      }
    };
    window.addEventListener('popstate', handlePopState, false);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [configurationActive?.isDetainment]);

  const handleDetainmentSubmit = () => {
    scrollToTop();
    setDetainmentVisible(false);
    isLeavingRef.current = false;

    report(`${pageName}_g_RetainPop_Stay_ClickUser_${l}`, {
      ...reportParams.current,
      event: 'g_RetainPop_Stay_ClickUser',
    });

    report(
      `${pageName}_g_RetainPop_Stay_Click_${l}`,
      {
        ...reportParams.current,
        event: 'g_RetainPop_Stay_Click',
      },
      true,
    );
  };

  const handleDetainmentCancel = () => {
    setDetainmentVisible(false);
    isLeavingRef.current = false;

    report(`${pageName}_g_RetainPop_Close_ClickUser_${l}`, {
      ...reportParams.current,
      event: 'g_RetainPop_Close_ClickUser',
    });

    report(
      `${pageName}_g_RetainPop_Close_Click_${l}`,
      {
        ...reportParams.current,
        event: 'g_RetainPop_Close_Click',
      },
      true,
    );
  };

  // 点击吸底按钮或悬浮按钮时开始计时
  const handleButtonTimer = () => {
    if (stayTimer) {
      clearTimeout(stayTimer);
    }
    if (isLeavingRef.current) {
      setStayTimer(window.setTimeout(() => detainmentOpenCloseRouter(), STAY_DELAY));
    }
  };

  const handleButtonClick = () => {
    if (officialWebsiteGa4) {
      sendGTag('entry_land_bottomsuction', { l_parameter: l });
    }

    handleToTop();
    if (configurationActive?.isDetainment) {
      handleButtonTimer();
    }
  };

  // 移开表单控件时重新开始计时
  const handleFormMouseLeave = () => {
    if (stayTimer) {
      clearTimeout(stayTimer);
    }
    if (isLeavingRef.current) {
      setLeaveTimer(window.setTimeout(() => detainmentOpenCloseRouter(), LEAVE_DELAY));
    }
  };

  // 移入表单控件时取消离开计时器
  const handleFormMouseEnter = () => {
    if (leaveTimer) {
      clearTimeout(leaveTimer);
    }
  };

  const handleFormValuesChange = () => {
    //  表单改变的时候 取消页面倒计时
    if (configurationActive?.isDetainment) {
      handleFormMouseEnter();
    }
  };

  const handleFormOnBlur = () => {
    //  表单改变的时候 取消页面倒计时
    if (configurationActive?.isDetainment) {
      handleFormMouseLeave();
    }
  };

  // 当组件被卸载时清除计时器
  useEffect(() => {
    return () => {
      if (leaveTimer) {
        clearTimeout(leaveTimer);
      }
      if (stayTimer) {
        clearTimeout(stayTimer);
      }
    };
  }, [leaveTimer, stayTimer]);

  useEffect(() => {
    // 微信调用静默登录 ，调用用户信息
    // 如果是  lp.wukongedu.net 或者 wukongedu.net，做相关处理
    // 获取当前网站域名
    // 微信环境并且不是小程序环境
    const currentDomain = window.location.hostname;

    if (
      isWechatEnvironment() &&
      !isMiniProgram() &&
      (currentDomain === 'lp.wukongedu.net' ||
        currentDomain === 'test.wukongedu.net' ||
        currentDomain === 'wukongedu.net')
    ) {
      authLogin({
        externalLogin: wechatLogin2,
        externalLoginExtraParams: { oauthType: 'WECHAT_PG' },
      })
        .then((status) => {
          if (status) {
            console.log('authLogin');
          }
        })
        .catch((err) => {
          console.log('authLogin err', err);
        });
    }

    if (isWechatEnvironment()) {
      setEnvironment('wx');
    } else {
      setEnvironment('h5');
    }
  }, []);

  // 切换语言 保存传入语言 更改页面默认数据
  const handleSelectLanguage = (lang: string) => {
    const eventName = lang === 'zh' ? 'languageChinese' : 'languageEnglish';
    report(
      `${pageName}_g_RetainPop_PV_${l}`,
      {
        ...reportParams.current,
        event: `g_FirstOrder_${eventName}_Click`,
      },
      true,
    );
    window.location.reload();
  };

  const navHeaderClick = () => {
    report(
      `${pageName}_g_FirstOrder_language_Click_${l}`,
      {
        ...reportParams.current,
        event: `g_FirstOrder_language_Click`,
      },
      true,
    );
  };
  const isPrivacyAgreementUserDecideForOneselfClick = (checked: boolean) => {
    handleClickReport(EVENT_NAME_MAP.FIRSTORDER_AGREEMENT_CLICK, {
      checked,
    });
  };

  const privacyAgreementInfo = useMemo(() => {
    let data = langText.privacyAgreementUser1;
    if (
      configurationActive?.isStudentName ||
      configurationActive?.isStudentAge ||
      configurationActive?.isStudentEnName
    ) {
      data = langText.privacyAgreementUser1b;
    }
    return data;
  }, [configurationActive, langText]);

  const privacyAgreementInfo5 = useMemo(() => {
    let data = langText.privacyAgreementUser5;
    if (
      configurationActive?.isStudentName ||
      configurationActive?.isStudentAge ||
      configurationActive?.isStudentEnName
    ) {
      data = langText.privacyAgreementUser5b;
    }
    return data;
  }, [configurationActive, langText]);

  const hide86 = useMemo(() => {
    // 如果手机号86 不隐藏
    // 专属版本 不隐藏
    if (formCountryCode === '+86') {
      console.log('1');
      return false;
    }
    if (configuration?.quizData?.showChinaDomestic) {
      console.log('2');
      return false;
    }
  }, [configuration, formCountryCode]);

  const canonical = (href: string | undefined) => {
    if (href?.includes('edu.net')) {
      return href?.replace('edu.net', 'sch.com');
    }
    return href;
  };

  const handleCloseVerify = () => {
    setVerifyDrawerVisible(false);
    setVerifyModalVisible(false);
  };

  return (
    <>
      {pixel.channel1 && pixel.channel2 === 'PIXEL' && pixel.channel2 === pixel.trackingCode && (
        <Script
          id="js-facebook-landing"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', 1032673631108666);
        `,
          }}
        />
      )}
      {pixel.channel1 && pixel.channel2 === 'PINTEREST' && pixel.channel2 === pixel.trackingCode && (
        <Script
          id="js-pinimg"
          dangerouslySetInnerHTML={{
            __html: `
        !function(e){if(!window.pintrk){window.pintrk = function () {
        window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
          n=window.pintrk;n.queue=[],n.version="3.0";var
          t=document.createElement("script");t.async=!0,t.src=e;var
          r=document.getElementsByTagName("script")[0];
          r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
        pintrk('load', '2612992790914', {em: 'xuewei.liang@wukongsch.com'});
        pintrk('page');
      `,
          }}
        />
      )}
      {environment === 'h5' && (
        <Script
          strategy="lazyOnload"
          id="taboola-landing"
          dangerouslySetInnerHTML={{
            __html: `
          window._tfa = window._tfa || [];  window._tfa.push({notify: 'event', name: 'page_view', id: 1618542});  !function (t, f, a, x) {         if (!document.getElementById(x)) {            t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);         }  }(document.createElement('script'),  document.getElementsByTagName('script')[0],  '//cdn.taboola.com/libtrc/unip/1618542/tfa.js',  'tb_tfa_script')
       `,
          }}
        />
      )}

      {pixel.channel1 && pixel.channel2 === 'XMLY' && pixel.channel2 === pixel.trackingCode && (
        <Script
          id="xmcdn"
          dangerouslySetInnerHTML={{
            __html: `
            (function (win, doc, src, version) {
              var sc = doc.createElement('script');
              sc.type = "text/javascript";
              sc.src = src + '?v=' + version;
              win.XMLY_ADOCPC_APPKEY = 'a767013c267c8fe443ea9ba4109eedff';
              var s = document.getElementsByTagName('script')[0];
              s.parentNode.insertBefore(sc, s);
              var xmlyAdLog = win.xmlyAdLog = win.xmlyAdLog || [];
              xmlyAdLog.track = xmlyAdLog.track || function (type, msg) {
                xmlyAdLog.push([type, msg]);
              }
            })(
              window,
              document,
              '//s1.xmcdn.com/yx/ad-jssdk-static/last/dist/app.min.js',
              new Date().getTime()
            );
    `,
          }}
        />
      )}
      {pixel.channel1 && pixel.channel2 === 'BING' && pixel.channel2 === pixel.trackingCode && (
        <Script
          id="xmcdn"
          dangerouslySetInnerHTML={{
            __html: `
            (function(w,d,t,r,u){
              var f,n,i;
              w[u]=w[u]||[],f=function(){
                var o={ti:"97106080"
              };
              o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){
                var s=this.readyState;
                s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
              },
              i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(
                window,document,"script","//bat.bing.com/bat.js","uetq"
              );
    `,
          }}
        />
      )}
      {pixel.trackingCode === 'WeiBo' && (
        <Script
          id="xmcdn"
          dangerouslySetInnerHTML={{
            __html: `
            (function () {
              const script = document.createElement('script');
              script.type = 'text/javascript';
              script.crossOrigin = 'anonymous';
              script.src = '//cheka.biz.weibo.com/snippet';
              // eslint-disable-next-line func-names
              script.onerror = function () {
                const img = document.createElement('img');
                img.src = '//cheka.biz.weibo.com/api/v1/events/collect?t=load.error&dl=${encodeURIComponent(
                  window.location.href,
                )}&rf=${encodeURIComponent(document.referrer)}&st=${performance.now()}&ts=${Date.now()}';
              };
              const s = document.getElementsByTagName('script')[0];
              s.parentNode.insertBefore(script, s);
            })(window);
    `,
          }}
        />
      )}
      {getIsGdtParams() && (
        <Script
          id="xmcdn"
          dangerouslySetInnerHTML={{
            __html: `
            !function(g,d,t,e,v,n,s){if(g.gdt)return;v=g.gdt=function(){v.tk?v.tk.apply(v,arguments):v.queue.push(arguments)};v.sv='1.0';v.bt=0;v.queue=[];n=d.createElement(t);n.async=!0; n.src=e;s=d.getElementsByTagName(t)[0];s.parentNode.insertBefore(n,s);}(window,document,'script', '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js');gdt('init','1201007301');gdt('init','1201007727');gdt('init','1201277648');gdt('track','PAGE_VIEW')
    `,
          }}
        />
      )}
      {(id === 'ST7LRWSx' || id === 'NLwKIJZy') && (
        <Script
          id="xmcdn"
          dangerouslySetInnerHTML={{
            __html: `
              !function(e){if(!window.pintrk){window.pintrk = function () {
              window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var
                n=window.pintrk;n.queue=[],n.version="3.0";var
                t=document.createElement("script");t.async=!0,t.src=e;var
                r=document.getElementsByTagName("script")[0];
                r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
              pintrk('load', '2612992790914', {em: 'xuewei.liang@wukongsch.com'});
              pintrk('page');
            `,
          }}
        />
      )}
      {pixel.channel1 && pixel.channel2 === 'Twitter' && pixel.channel2 === pixel.trackingCode && (
        <Script
          id="Twitter"
          dangerouslySetInnerHTML={{
            __html: `
            !function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);
            },s.version='1.1',s.queue=[],u=t.createElement(n),u.async=!0,u.src='https://static.ads-twitter.com/uwt.js',
            a=t.getElementsByTagName(n)[0],a.parentNode.insertBefore(u,a))}(window,document,'script');
            twq('config','o6gtr');
    `,
          }}
        />
      )}
      {pixel.channel1 && pixel.channel2 === 'TikTok' && pixel.channel2 === pixel.trackingCode && (
        <Script
          id="tiktok"
          dangerouslySetInnerHTML={{
            __html: `
              !function (w, d, t) {
                w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie"],ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}};for(var i=0;i<ttq.methods.length;i++)ttq.setAndDefer(ttq,ttq.methods[i]);ttq.instance=function(t){for(var e=ttq._i[t]||[],n=0;n<ttq.methods.length;n++)ttq.setAndDefer(e,ttq.methods[n]);return e},ttq.load=function(e,n){var i="https://analytics.tiktok.com/i18n/pixel/events.js";ttq._i=ttq._i||{},ttq._i[e]=[],ttq._i[e]._u=i,ttq._t=ttq._t||{},ttq._t[e]=+new Date,ttq._o=ttq._o||{},ttq._o[e]=n||{};var o=document.createElement("script");o.type="text/javascript",o.async=!0,o.src=i+"?sdkid="+e+"&lib="+t;var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(o,a)};
              
                ttq.load('CMJRMORC77UF4ULPBOR0');
                ttq.page();
              }(window, document, 'ttq');
      `,
          }}
        />
      )}
      {configuration?.quizData?.language === 'CH_EN' && (
        <Nav
          theme={
            week === 'fri'
              ? 'CHINESE'
              : (configuration.quizData?.subject as 'MATH' | 'CHINESE' | 'ENGLISH') || 'CHINESE'
          }
          handleSelectLanguage={handleSelectLanguage}
          navHeaderClick={navHeaderClick}
        />
      )}
      <div
        className={classNames(styles.container, styles[`container-${styleType}`], {
          [styles.containerMath]: week !== 'fri' && configuration.quizData?.subject === 'MATH',
          [styles.containerEnglish]: week !== 'fri' && configuration.quizData?.subject === 'ENGLISH',
          [styles.containerEn]: language === 'EN',
        })}
      >
        <Head>
          <title>{langText.pageTitle}</title>
          <noscript>
            <img
              height="1"
              width="1"
              style={{ display: 'none' }}
              src="https://www.facebook.com/tr?id=1032673631108666&ev=PageView&noscript=1"
            />
          </noscript>
          {pixel.channel1 && pixel.channel2 === 'SHARE_A_SALE' && pixel.channel2 === pixel.trackingCode && (
            <script src="https://www.dwin1.com/19038.js" type="text/javascript" defer />
          )}
          <style>{`
              body, * {
                font-family: ${
                  language === 'EN'
                    ? '"Roboto","sans-serif"'
                    : '"PingFang SC", "Microsoft YaHei", "Helvetica Neue","Helvetica","Hiragino Sans GB", "sans-serif"'
                };
              }
        `}</style>
          <link rel="canonical" href={canonical(state?.href)} />
          <meta name="page_id" content={'000003'} />
        </Head>
        <div className={styles.containerInner}>
          {topTipsCon()}

          <div className={styles.banner} ref={bannerRef}>
            {certificateLearningHtml()}
            <div className={styles.bannerBg}>
              {configurationActive?.bannerImageUrlLink && (
                <ImageNext
                  className={styles.bannerBgImg}
                  src={configurationActive?.bannerImageUrlLink}
                  alt=""
                  width={1920}
                  height={800}
                  priority={true}
                />
              )}
            </div>

            <div className={styles.bannerCon}>
              <div className={styles.rightFromBox}>
                <div
                  className={styles.formBoxBg}
                  style={{
                    background: configurationActive?.formTitleBackgroundColor || '#fff',
                  }}
                >
                  <RCForm
                    form={form}
                    onClick={handleFormClick}
                    className={styles.form}
                    onFinish={handleFinish}
                    onFinishFailed={handleModalFinishFailed}
                    onValuesChange={handleFormValuesChange}
                    onBlur={handleFormOnBlur}
                  >
                    <div className={styles.formBox}>
                      {/* 无标题空白间隔 */}
                      {!configurationActive?.isTitleContinuer && <div className={styles.formTitleEmpty} />}

                      {!isAppSource && configurationActive?.isTitleContinuer && (
                        <div className={styles.formTitle}>
                          <span className={styles.longPressIcon} />
                          <span>{configurationActive?.title1}</span>
                          {configurationActive?.title2}
                          <span className={styles.longPressIconRight} />
                        </div>
                      )}

                      {configurationActive?.isPhone && !isAppSource && (
                        <>
                          {isMobile ? (
                            <FormItem
                              className={styles.fixFormItem}
                              errClassName={styles.errClassName}
                              name="phone"
                              label=""
                              initialValue={['+1', formDefaultData?.phone]}
                              phoneShowErr={twillio}
                              phoneError={langText.formPhoneIncorrectFormat}
                              rules={[
                                {
                                  validator(_, value) {
                                    setStartPhoneCode(value[0]);
                                    let ruleLength: number = 4;
                                    // if (countryData.countryCode === value[0]) {
                                    //   ruleLength = Number(countryData.ml || '6');
                                    // } else {
                                    //   ruleLength = Number(value[3] || '6');
                                    // }
                                    if (!value || !value[1]) {
                                      const formType = configuration.quizData?.formType;
                                      if (formType === 'CLASS' || formType === 'CLASS_BOOKING') {
                                        return Promise.reject(new Error(langText.formStudentPhoneEmpty));
                                      }
                                      return Promise.reject(new Error(langText.formPhoneEmpty));
                                    }

                                    if (!PHONE_REG.test(value[1])) {
                                      return Promise.reject(new Error(langText.formPhoneIncorrectFormat));
                                    }

                                    if (configurationActive?.isPhoneVerify && value[1].length >= ruleLength) {
                                      setIsPhoneVerify(true);
                                    } else if (value[0] === '+886' && value[1].slice(0, 5) === '99999') {
                                      setIsPhoneVerify(false);
                                      setIsSpecialCode(true);
                                    } else {
                                      setIsPhoneVerify(startPhone !== value[0] && value[1].length >= ruleLength);
                                    }

                                    if (value[1].length >= ruleLength) {
                                      setIsEmailInput(true);
                                    }

                                    setIsAgeInput(true);
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <PhoneInputMobile
                                inputClassName={styles.phoneInput}
                                placeholder={configurationActive?.phonePlaceholderValue}
                                countryCodeClassName={classNames({
                                  [styles.countryCodeDisabled]: formTypeConfig.current?.phoneSelectDisabled,
                                })}
                                language={language === 'EN' ? 'en' : 'zh'}
                                disabledSelect={formTypeConfig.current?.phoneSelectDisabled}
                                disabledInput={formTypeConfig.current?.phoneInputDisabled}
                                phoneVisible={formTypeConfig.current.phoneVisible}
                                inputOnBlur={handlePhoneInputOnBlur}
                                countryCodeChange={handlePhoneInputOnBlur}
                                handleReport={handleClickReport}
                                handlePhoneChange={() => {
                                  setTwillio(false);
                                  setTwillioResponse(true);
                                }}
                                hide86={hide86}
                              />
                            </FormItem>
                          ) : (
                            <FormItem
                              className={styles.fixFormItem}
                              errClassName={styles.errClassName}
                              name="phone"
                              label=""
                              initialValue={['+1', formDefaultData?.phone]}
                              phoneShowErr={twillio}
                              phoneError={langText.formPhoneIncorrectFormat}
                              rules={[
                                {
                                  validator(_, value) {
                                    setStartPhoneCode(value[0]);
                                    const formType = configuration.quizData?.formType;
                                    let ruleLength: number = 4;
                                    // if (countryData.countryCode === value[0]) {
                                    //   ruleLength = Number(countryData.ml);
                                    // } else {
                                    //   ruleLength = Number(value[3] || '6');
                                    // }
                                    if (!value || !value[1]) {
                                      if (formType === 'CLASS' || formType === 'CLASS_BOOKING') {
                                        return Promise.reject(new Error(langText.formStudentPhoneEmpty));
                                      }
                                      return Promise.reject(new Error(langText.formPhoneEmpty));
                                    }

                                    if (!PHONE_REG.test(value[1])) {
                                      return Promise.reject(new Error(langText.formPhoneIncorrectFormat));
                                    }

                                    if (configurationActive?.isPhoneVerify && value[1].length >= ruleLength) {
                                      setIsPhoneVerify(true);
                                    } else if (value[0] === '+886' && value[1].slice(0, 5) === '99999') {
                                      setIsPhoneVerify(false);
                                      setIsSpecialCode(true);
                                    } else {
                                      setIsPhoneVerify(startPhone !== value[0] && value[1].length >= ruleLength);
                                    }

                                    if (value[1].length >= ruleLength) {
                                      setIsEmailInput(true);
                                    }

                                    setIsAgeInput(true);
                                    return Promise.resolve();
                                  },
                                },
                              ]}
                            >
                              <PhoneInput
                                countryCode={countryCode}
                                placeholder={configurationActive?.phonePlaceholderValue}
                                inputClassName={styles.phoneInput}
                                language={language === 'EN' ? 'en' : 'zh'}
                                disabledSelect={formTypeConfig.current?.phoneSelectDisabled}
                                disabledInput={formTypeConfig.current?.phoneInputDisabled}
                                phoneVisible={formTypeConfig.current.phoneVisible}
                                inputOnBlur={handlePhoneInputOnBlur}
                                countryCodeChange={handlePhoneInputOnBlur}
                                handleReport={handleClickReport}
                                handlePhoneChange={() => {
                                  setTwillio(false);
                                  setTwillioResponse(true);
                                }}
                              />
                            </FormItem>
                          )}
                        </>
                      )}
                      {/* app source */}
                      {isAppSource && <></>}
                      {configurationActive?.isEmail && !isAppSource && (isEmailInput || isGetStudentInfo) && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="mail"
                          label=""
                          rules={[
                            {
                              validator(_, value) {
                                // 不能全是空格 或者为空

                                //  数学+86邮箱非彼填写
                                const isP86 = configuration.quizData?.subject === 'MATH' && startPhoneCode === '+86';

                                const length = value?.split(' ')?.join('')?.length;

                                if (!length && !isP86) {
                                  return Promise.reject(new Error(langText.formEmailEmpty));
                                }

                                if (length && !EMAIL_REG.test(value)) {
                                  return Promise.reject(new Error(langText.formEmailIncorrectFormat));
                                }

                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            className={classNames(styles.fixInput, styles.input)}
                            placeholder={configurationActive?.emailPlaceholderValue}
                            maxLength={50}
                            name="mail"
                            onBlur={() => doTrackList([FIELDS_MAP.EMAIL_CLICK, FIELDS_MAP.EMAIL_CLICK_USER])}
                            onClick={() => handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMEMAIL_CLICK)}
                          />
                        </FormItem>
                      )}
                      {configurationActive?.isStudentName && !isAppSource && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="name"
                          label=""
                          initialValue={formDefaultData?.name}
                          rules={[
                            {
                              validator(_, value) {
                                // 不能全是空格 或者为空
                                const length = value?.split(' ')?.join('')?.length;
                                const formType = configuration.quizData?.formType;
                                if (!length) {
                                  if (formType === 'CLASS' || formType === 'CLASS_BOOKING') {
                                    return Promise.reject(new Error(langText.formStudentNameEmpty));
                                  }
                                  return Promise.reject(new Error(langText.formNameEmpty));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            className={classNames(styles.fixInput, styles.input)}
                            placeholder={configurationActive?.studentNamePlaceholderValue}
                            maxLength={50}
                            name="name"
                            disabled={formTypeConfig.current?.StudentNameInputDisabled}
                            onBlur={() =>
                              doTrackList([FIELDS_MAP.STUDENT_NAME_CLICK, FIELDS_MAP.STUDENT_NAME_CLICK_USER])
                            }
                            onClick={() => handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMSTUDENTNAME_CLICK)}
                          />
                        </FormItem>
                      )}
                      {configurationActive?.isStudentEnName && !isAppSource && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="englishName"
                          label=""
                          initialValue={formDefaultData?.englishName}
                          rules={[
                            {
                              validator(_, value) {
                                // 不能全是空格 或者为空
                                const length = value?.split(' ')?.join('')?.length;
                                const formType = configuration.quizData?.formType;
                                if (!length) {
                                  if (formType === 'CLASS' || formType === 'CLASS_BOOKING') {
                                    return Promise.reject(new Error(langText.formStudentEnglishNameEmpty));
                                  }
                                  return Promise.reject(new Error(langText.formEnglishNameEmpty));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            className={classNames(styles.fixInput, styles.input)}
                            placeholder={configurationActive?.studentEnNamePlaceholderValue}
                            maxLength={50}
                            name="englishName"
                            disabled={formTypeConfig.current?.StudentEnglishNameInputDisabled}
                            onBlur={() =>
                              doTrackList([FIELDS_MAP.ENGLISH_NAME_CLICK, FIELDS_MAP.ENGLISH_NAME_CLICK_USER])
                            }
                          />
                        </FormItem>
                      )}
                      {configurationActive?.isStudentAge && !isAppSource && (isAgeInput || isGetStudentInfo) && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="age"
                          label=""
                          initialValue={formDefaultData?.age}
                          rules={[{ required: true, message: langText.formAgeFormat }]}
                        >
                          <Select
                            name="age"
                            placeholder={
                              configurationActive?.studentAgePlaceholderValue
                                ? configurationActive?.studentAgePlaceholderValue
                                : langText.formAgePlaceholder
                            }
                            classNamePrefix="select"
                            // formatOptionLabel={(option) => `${option.label}${langText.formAge}`}
                            className={styles.select}
                            isSearchable={false}
                            options={getAgeOptions(configuration.quizData?.subject || 'CHINESE', language)}
                            onBlur={() => {
                              doTrackList([FIELDS_MAP.AGE_CLICK, FIELDS_MAP.AGE_CLICK_USER]);
                              handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMLANGUAGE_CLICK);
                            }}
                          />
                        </FormItem>
                      )}
                      {configurationActive?.isStudentGrade &&
                        !isAppSource &&
                        configuration.quizData?.subject !== 'CHINESE' && (
                          <FormItem
                            className={styles.fixFormItem}
                            errClassName={styles.errClassName}
                            name="grade"
                            label=""
                            initialValue={formDefaultData?.grade}
                            rules={[{ required: true, message: langText.formGradeFormat }]}
                          >
                            <Select
                              name="grade"
                              placeholder={
                                configurationActive?.studentHomeGradePlaceholderValue
                                  ? configurationActive?.studentHomeGradePlaceholderValue
                                  : langText.formHomeGradePlaceholder
                              }
                              classNamePrefix="select"
                              // formatOptionLabel={(option) => `${option.label}${langText.formAge}`}
                              className={styles.select}
                              isSearchable={false}
                              options={getGradeOptions(language, gradeListByRequest)}
                              onBlur={() => {
                                doTrackList([FIELDS_MAP.AGE_CLICK, FIELDS_MAP.AGE_CLICK_USER]);
                                handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMLANGUAGE_CLICK);
                              }}
                            />
                          </FormItem>
                        )}
                      {configurationActive?.isButtLanguage && !isAppSource && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="serveLanguage"
                          rules={[
                            {
                              required: true,
                              message: langText.formLanguageEmpty,
                            },
                          ]}
                        >
                          <Select
                            name="serveLanguage"
                            placeholder={
                              configurationActive?.buttLanguagePlaceholderValue
                                ? configurationActive?.buttLanguagePlaceholderValue
                                : langText.formLanguagePlaceholder
                            }
                            classNamePrefix="select"
                            className={styles.select}
                            isSearchable={false}
                            options={language === 'EN' ? LANGUAGE_EN : LANGUAGE_ZH}
                            onBlur={() => {
                              doTrackList([FIELDS_MAP.SERVE_LANGUAGE_CLICK, FIELDS_MAP.SERVE_LANGUAGE_CLICK_USER]);
                              handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMLANGUAGE_CLICK);
                            }}
                          />
                        </FormItem>
                      )}
                      {configurationActive?.isStudentCode && !isAppSource && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="studentCode"
                          label=""
                          initialValue={formDefaultData?.studentCode}
                          rules={[
                            {
                              validator(_, value) {
                                // 不能全是空格 或者为空
                                const length = value?.split(' ')?.join('')?.length;
                                const formType = configuration.quizData?.formType;
                                if (!length) {
                                  if (formType === 'CLASS' || formType === 'CLASS_BOOKING') {
                                    return Promise.reject(new Error(langText.formStudentCodeEmpty));
                                  }
                                  return Promise.reject(new Error(langText.formEmpty));
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            className={classNames(styles.fixInput, styles.input)}
                            placeholder={configurationActive?.studentCodePlaceholderValue}
                            maxLength={50}
                            name="studentCode"
                            disabled={formTypeConfig.current?.studentCodeInputDisabled}
                            onBlur={() =>
                              doTrackList([FIELDS_MAP.STUDENT_CODE_CLICK, FIELDS_MAP.STUDENT_CODE_CLICK_USER])
                            }
                          />
                        </FormItem>
                      )}

                      {configurationActive?.isCustomInput1 && !isAppSource && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="customInput1Key"
                          label=""
                          rules={[
                            {
                              validator(_, value) {
                                // 不能全是空格 或者为空
                                const length = value?.split(' ')?.join('')?.length;
                                if (!length) {
                                  return Promise.reject(
                                    new Error(configurationActive?.customInput1EmptyTips || langText.formEmpty),
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            className={classNames(styles.fixInput, styles.input)}
                            placeholder={configurationActive?.customInput1Value}
                            maxLength={50}
                            name="customInput1Key"
                            onBlur={() =>
                              doTrackList([FIELDS_MAP.CUSTOM_INPUT_1_CLICK, FIELDS_MAP.CUSTOM_INPUT_1_CLICK_USER])
                            }
                            onClick={() => handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMCUSTOMINPUT1_CLICK)}
                          />
                        </FormItem>
                      )}

                      {configurationActive?.isCustomInput2 && !isAppSource && (
                        <FormItem
                          className={styles.fixFormItem}
                          errClassName={styles.errClassName}
                          name="customInput2Key"
                          label=""
                          rules={[
                            {
                              validator(_, value) {
                                // 不能全是空格 或者为空
                                const length = value?.split(' ')?.join('')?.length;
                                if (!length) {
                                  return Promise.reject(
                                    new Error(configurationActive?.customInput2EmptyTips || '不能为空'),
                                  );
                                }
                                return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <Input
                            className={classNames(styles.fixInput, styles.input)}
                            placeholder={configurationActive?.customInput2Value}
                            maxLength={50}
                            name="customInput2Key"
                            onBlur={() =>
                              doTrackList([FIELDS_MAP.CUSTOM_INPUT_2_CLICK, FIELDS_MAP.CUSTOM_INPUT_2_CLICK_USER])
                            }
                            onClick={() => handleClickReport(EVENT_NAME_MAP.FIRSTORDER_FORMCUSTOMINPUT2_CLICK)}
                          />
                        </FormItem>
                      )}

                      {/* <div className={styles.formBtn}>点击免费领取</div> */}
                      {checkedError && <p className={styles.checkedErrorTips}>{langText.agreePrivacyAgreement}</p>}
                      {isAppSource && configurationActive && !isEmpty(configurationActive) && (
                        <Button
                          block
                          className={styles.btn}
                          onClick={() => {
                            handleClickReport(EVENT_NAME_MAP.FIRSTORDER_SUBMITBUTTON_CLICK, {
                              button_name: configurationActive?.submitButtonValue,
                            });
                            appSubmit();
                          }}
                        >
                          {configurationActive?.submitButtonValue}
                        </Button>
                      )}
                      {!isAppSource && configurationActive && !isEmpty(configurationActive) && (
                        <Button
                          type="submit"
                          block
                          className={styles.btn}
                          onClick={() => {
                            if (officialWebsiteGa4) {
                              sendGTag('collection_land_firstscreen', { l_parameter: l });
                            }
                          }}
                        >
                          {configurationActive?.submitButtonValue}
                          {configurationActive?.isButtonCountDown && (
                            <span className={styles.btnRight}>
                              <Countdown countdownNum={10} />
                            </span>
                          )}
                        </Button>
                      )}
                    </div>
                  </RCForm>
                  {configurationActive?.isPrivacyAgreement &&
                    !configurationActive?.isPrivacyAgreementUserDecideForOneself && (
                      <div className={styles.privacy}>
                        <span className={styles.privacyIcon} />
                        {langText.formPrivacy}
                      </div>
                    )}
                  {configurationActive?.isPrivacyAgreement &&
                    configurationActive?.isPrivacyAgreementUserDecideForOneself && (
                      <div
                        className={classNames(
                          styles.formRadio,
                          configuration.quizData?.subject === 'MATH' && week !== 'fri' && styles.mathInputRadio,
                          configuration.quizData?.subject === 'ENGLISH' && week !== 'fri' && styles.englishInputRadio,
                        )}
                      >
                        <input
                          type="checkbox"
                          id="inputId"
                          checked={checked}
                          onChange={(e) => {
                            setChecked(e?.target?.checked);
                            checkedRef.current = e?.target?.checked;
                            setCheckedError(!e?.target?.checked);
                            isPrivacyAgreementUserDecideForOneselfClick(e?.target?.checked);
                          }}
                          onBlur={() => doTrackList([FIELDS_MAP.AGREEMENT_CLICK, FIELDS_MAP.AGREEMENT_CLICK_USER])}
                        />
                        <label htmlFor="inputId" />
                        <span>
                          {privacyAgreementInfo}
                          <a
                            href="https://student.wukongedu.net/agreement"
                            target="_blank"
                            rel="noreferrer"
                            className={classNames(
                              configuration.quizData?.subject === 'MATH' && week !== 'fri' && styles.mathBlank,
                              configuration.quizData?.subject === 'ENGLISH' && week !== 'fri' && styles.englishBlank,
                            )}
                          >
                            {langText.privacyAgreementUser2}
                          </a>{' '}
                          {langText.privacyAgreementUser3}
                          <a
                            href="https://www.wukongsch.com/policy"
                            target="_blank"
                            rel="noreferrer"
                            className={classNames(
                              configuration.quizData?.subject === 'MATH' && week !== 'fri' && styles.mathBlank,
                              configuration.quizData?.subject === 'ENGLISH' && week !== 'fri' && styles.englishBlank,
                            )}
                          >
                            {' '}
                            {langText.privacyAgreementUser4}
                          </a>
                          {privacyAgreementInfo5}
                        </span>
                      </div>
                    )}
                  {!configurationActive?.isPrivacyAgreement &&
                    !configurationActive?.isPrivacyAgreementUserDecideForOneself && (
                      <div className={classNames(styles.privacyLeaveBlank)} />
                    )}

                  <div className={styles.formWelfareBox}>
                    <img src={configurationActive?.occupiedImageUrlLink} alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          {configurationActive?.isLevitationBtn && (
            <div
              className={classNames(styles.imgBox, sideHide && styles.imgBoxIn)}
              onClick={() => {
                handleButtonClick();
                handleClickReport(EVENT_NAME_MAP.FIRSTORDER_LEVITATIONBUTTON_CLICK);
              }}
            >
              <div className={classNames(styles.innerBox)}>
                <img src={configurationActive?.levitationBtnImg} alt="" />
              </div>
            </div>
          )}

          <div className={styles.imageContent}>
            {configurationActive?.publicityImgListBase64 &&
              Array.isArray(configurationActive?.publicityImgListBase64) &&
              configurationActive?.publicityImgListBase64?.map(
                (item, index) =>
                  item?.url && (
                    <div key={index} className={styles.imageItem}>
                      <Image
                        src={item.url}
                        alt=""
                        width={1920}
                        height={800}
                        sizes="100vw"
                        // quality="85"
                        style={{
                          objectFit: 'cover',
                          width: '100%',
                          height: 'auto',
                        }}
                        // placeholder="blur"
                      />
                    </div>
                  ),
              )}
          </div>
          <div className={classNames(styles.suspensionButton, hideBtn && styles.footerIn)}>
            <div className={styles.suspensionButtonContent}>
              <PC>
                <div className={styles.suspensionButtonContentLeft}>
                  <div className={styles.ip5}>
                    <ImageNext
                      src={getPCFixed(configuration.quizData?.subject || 'CHINESE', langText)?.leftImg}
                      alt=""
                      fill
                    />
                  </div>

                  <div className={styles.suspensionButtonTextBox}>
                    <div className={styles.suspensionLogo}>
                      <ImageNext
                        src={getPCFixed(configuration.quizData?.subject || 'CHINESE', langText)?.centerImg}
                        alt=""
                        width="136"
                        height="45"
                      />
                    </div>
                    <p className={styles.suspensionButtonText}>
                      {getPCFixed(configuration.quizData?.subject || 'CHINESE', langText)?.centerText}
                    </p>
                  </div>
                </div>
              </PC>

              <Button block className={classNames(styles.suspensionBtn, styles.btn)} onClick={handleButtonClick}>
                {configurationActive?.submitButtonValue}
                {configurationActive?.isButtonCountDown && (
                  <span className={styles.btnRight}>
                    <Countdown countdownNum={10} />
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {configurationActive?.isDetainment && (
        <DetainmentModal
          visible={detainmentVisible}
          onSubmit={handleDetainmentSubmit}
          onCancel={handleDetainmentCancel}
          conImg={configurationActive?.detainmentImgUrlLink}
          okText={configurationActive?.detainmentOkWord}
          cancelText={configurationActive?.detainmentCancelWord}
        />
      )}
      {!!language && !!configuration.quizData?.subject ? (
        isMobile ? (
          <VerifyDrawer
            phoneVerifyPlaceholderValue={configurationActive?.phoneVerifyPlaceholderValue || ''}
            visible={verifyDrawerVisible}
            onHandleVerifyDrawerVisible={memorizedHandleVerifyDrawerVisible}
            language={language}
            handleSubmit={handleFinishAfter}
            themeColor={week === 'fri' ? 'CHINESE' : getThemeColor(configuration.quizData?.subject || 'CHINESE')}
            initValue={[formValues?.phone?.[0] ?? '', formValues?.phone?.[1] ?? '']}
            reportParams={{ ...reportParams.current, l, event: '' }}
            pageName={pageName}
            hide86={hide86}
          />
        ) : (
          <VerifyModal
            phoneVerifyPlaceholderValue={configurationActive?.phoneVerifyPlaceholderValue || ''}
            visible={verifyModalVisible}
            onHandleVerifyModalVisible={memorizedHandleVerifyModalVisible}
            language={language}
            handleSubmit={handleFinishAfter}
            themeColor={week === 'fri' ? 'CHINESE' : getThemeColor(configuration.quizData?.subject || 'CHINESE')}
            initValue={[formValues?.phone?.[0] ?? '', formValues?.phone?.[1] ?? '']}
            reportParams={{ ...reportParams.current, l, event: '' }}
            pageName={pageName}
          />
        )
      ) : null}
    </>
  );
};

export default withGTMInjectScript(ChineseLanding, { ...GTM_FORM_CONFIGURABLE });
